import { Location } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import $ from 'jquery';
import { Base64 } from 'js-base64';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { OrderDetails, PaymentId } from '@src/app/ecom-models/order-details';
import { User } from '@src/app/ecom-models/user';
import { EcomSettingService } from '@src/app/ecom-services/ecom-setting.service';
import { EcomValidator } from '@src/app/ecom-services/ecom-validation';
import { QRType } from '@src/app/enums/qr-types.enum';
import { ToastService } from '@src/app/toast/toast.service';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import * as QRCode from 'qrcode';
import { Subject } from 'rxjs';
import { finalize, first, takeUntil, tap } from 'rxjs/operators';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { StoreCartBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storecartbase';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { EmailBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-useremailbase';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { LoadingService } from 'src/app/ecom-shared/loading-component/loading-service';
import { WindowRef } from 'src/app/ecom-support-center/zoho-salesiq/WindowRef';
import { default as olarconfig } from '../../../assets/olarconfig.json';
import { EcomCookies } from '../../ecom-services/ecom-cookies';

@Component({
  selector: 'app-ecom-item-cart-checkout',
  templateUrl: './ecom-item-cart-checkout.component.html',
  styleUrls: ['./ecom-item-cart-checkout.component.scss'],
  providers: [WindowRef]
})
export class EcomItemCartCheckoutComponent implements OnInit, OnDestroy {

  // component class properties

  clickEvent = '';
  public checkoutform: FormGroup;

  serviceType = 'DINE_IN';
  settings: any;
  locationSelected: any;

  userServiceBase: UserServiceBase;
  userSelectedStore: StoreServiceBase;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  selectedCountryISO: any = CountryISO.Malaysia;
  preferredCountries: CountryISO[] = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];


  url = 'home';

  modalRef: BsModalRef;

  modalQrPaymentRef: BsModalRef;
  config = {
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: false,
    keyboard: true
  };
  @ViewChild('signup', { static: true }) signup: ElementRef;

  username: any;
  usercontact: any;

  qrCodeScanned = false;
  deliveryCharges = 0;
  retrycount = 0;
  alerts: any[] = [{
    type: 'warning',
    msg: 'limit exceeds',
    timeout: 5000,
    isOpen: false
  }];
  usertoken: any;
  signupmobile: any;
  signupform: FormGroup;


  // payments related

  paymentModeSelected: any;
  @ViewChild('paymentfailure', { static: true }) paymentfailure: ElementRef;

  @ViewChild('qrPayment', { static: true }) qrPayment: ElementRef;

  @ViewChild('cancelQrPayment', { static: true }) cancelQrPayment: ElementRef;

  @ViewChild('sessionEnded', { static: true }) sessionEnded: ElementRef;


  chargetoRoom = false;
  paymentTypeSelected: any;
  PaymentTypeSelectedName = '';

  environment: any;

  PaymentAmount = 0;

  rhPaymentForm: FormGroup;
  //AmBankPaymentForm: FormGroup;

  @ViewChild('applyPromo', { static: true }) applyPromo: ElementRef;
  modalRefOlarmePromotion: BsModalRef;

  modalRefOlars: BsModalRef;

  isRedeem: any = false;
  redeemAmount = 0;
  redeemPoints: any;

  distance = 0;
  orderDatetime: any;

  @ViewChild('sessionExpired', { static: true }) sessionExpired: ElementRef;
  configsessionExpired = {
    ignoreBackdropClick: true,
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered modal-sm'
  };
  sessionModalRef: BsModalRef;

  overlayDisplay = false;
  window: any;

  areaList = [];
  @ViewChild(BsDatepickerDirective, { static: false }) datepicker: BsDatepickerDirective;

  amountToPayFromCart = 0;
  amountToPay = 0;
  balanceToPay = 0;

  showonlinePayments = true;
  //loaylty points window
  modalRefLoyalty: BsModalRef;
  @ViewChild('displayLoyalty', { static: true }) displayLoyalty: ElementRef;
  configloyalty = {
    animated: true,
    class: 'modal-dialog-centered modal-sm modal-loyalty-payment',
    ignoreBackdropClick: false,
    keyboard: true
  };
  loayltyPoints = 0;
  showPayAtCounter = false;
  clickCount = 0;
  IsLocationQRCode = false;
  // constructor to inject the class objects
  // order status popup 
  configorderstatus = {
    ignoreBackdropClick: true,
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered modal-sm'
  };
  orderstatusModalRef: BsModalRef;
  customer_order: any;

  paymentGateway = '';
  //ghlPaymentForm: FormGroup;
  // customer details popup
  @ViewChild('customerDetails', { static: true }) customerDetails: ElementRef;
  configCustomerDetails = {
    ignoreBackdropClick: true,
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered modal-sm'
  };
  customerDetailsModalRef: BsModalRef;
  customerDetailsForm: FormGroup;
  displayPaymentSpecific = false;
  toastMessage: string = '';
  showToast: boolean = false;
  QRCodeType: number;
  paymentTypes: any[] = [];
  userInfo: User;
  loyaltyAmount = 0;
  remainingPoints = 0;
  isLoading: boolean;
  paymentDone: boolean = false;
  paymentResponse: string;
  qrImageSrc: SafeResourceUrl;
  qrDuitNowData: any;

  displayTime: string = '03:00';
  interval: any;
  readonly countdownKey = 'countdown_end_time';
  readonly countdownDuration = 3 * 60 * 1000; // 3 phút in ms
  requestId: any;
  showMessageAfter1Min: boolean = false;
  isManual: boolean;
  inquiryCount: number;
  inquiryMessage: string;
  bankResult: any;
  constructor(public commonLoading: LoadingService, private el: ElementRef, public formBuilder: FormBuilder, public router: Router, public ecomservice: EComService,
    public location: Location, public activatedRoute: ActivatedRoute, private cookie: EcomCookies,
    public webstorage: EComWebStorage, private modalService: BsModalService,
    private toastService: ToastService,
    private settingService: EcomSettingService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer) {
    this.environment = olarconfig.Environment;

    this.paymentGateway = this.ecomservice.GetOlarConfigValue('PaymentGateway');
    this.toastService.message$.subscribe(message => {
      this.toastMessage = message;
    });

    this.toastService.visibility$.subscribe(visible => {
      this.showToast = visible;
    });
    this.settingService.currentCompanySetting.subscribe(setting => {
      if (!setting) return;

      this.serviceType = setting.serviceType;
      this.locationSelected = setting;
    });

    this.settingService.currentLocationSetting.subscribe(location => {
      if (!location) return;

      this.userSelectedStore = this.settingService.getSelectedStore(this.serviceType);
      this.settings = location;
    });


    this.settingService.currentQRCodeType.subscribe(value => {
      this.QRCodeType = value;
    });

    this.settingService.currentUserInfo.subscribe(user => {
      this.userInfo = user;
    });

    this.router.events.subscribe((event: NavigationStart) => {
      if (event.navigationTrigger === 'popstate') {
        // Perform actions when the back button is pressed
        console.log('Back button pressed!');
      }
    });

    if (this.environment === 'Production') {
      const excludedTypes = ['duitnow'];

      this.defaultPaymentTypes = this.defaultPaymentTypes.filter(
        x => !excludedTypes.includes(x.type.toLocaleLowerCase())
      );
    }
  }

  preventNegativeInput(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'Minus' || event.key === '.' || event.key === ',') {
      event.preventDefault();
    }
  }

  get allowedPointsToUse(): number {
    const payAmount = +this.amountToPay.toFixed(2);
    return Math.floor(
      Math.min(
        this.userInfo.points / this.userInfo.ratio,
        this.userInfo.maximum_redemtion,
        payAmount
      )
    );
  }


  onInputLimit(event: any) {
    let rawValue = event.target.value;

    rawValue = rawValue.replace(/[^0-9]/g, '');

    let value = Number(rawValue);

    if (value > this.allowedPointsToUse) {
      this.loyaltyAmount = this.allowedPointsToUse;
      event.target.value = this.allowedPointsToUse;
    }

    this.remainingPoints = this.loyaltyAmount * this.userInfo.ratio;
    this.setPayment();
  }


  get getAmountToPay(): string {
    const value = this.balanceToPay - this.loyaltyAmount;
    return Math.abs(value) < 0.005 ? '0.00' : value.toFixed(2);
  }

  onPointsChanged() {
    this.payatcountenabled = false;
    if (this.loyaltyAmount < 0) {
      this.loyaltyAmount = 0;
    }

    if (this.loyaltyAmount > this.allowedPointsToUse) {
      // setTimeout(() => {
      //   this.loyaltyAmount = this.loyaltyAmount;
      //   this.remainingPoints = this.loyaltyAmount * this.userInfo.ratio;
      //   console.log(this.loyaltyAmount);
      // }, 500);
      this.loyaltyAmount = this.allowedPointsToUse;
      this.remainingPoints = this.loyaltyAmount * this.userInfo.ratio;
    }
    this.hidePayAtCounter();

    this.remainingPoints = this.loyaltyAmount * this.userInfo.ratio;
    const hasRewardItem = this.userSelectedStore.storeCart.orderItems
      .some(item => item.hasReward);

    if (!hasRewardItem) {
      this.setPayment();
    }

    this.paymentTypes.forEach(paymentType => {
      paymentType.selected = '';
      paymentType.option_selected = false;

      [...paymentType.staging_list, ...paymentType.production_list].forEach(ptype => {
        ptype.selected = false;
      });
    });

    if (this.loyaltyAmount > 0) {
      this.hidePayAtCounter();
    }


    if (this.loyaltyAmount > this.allowedPointsToUse) {
      this.loyaltyAmount = this.allowedPointsToUse;
    }

    if (this.balanceToPay - this.loyaltyAmount === 0) {
      this.paymentTypes = [{
        type: 'loyalty',
        collapsed: true,
        name: 'Loyalty',
        selected: 'loyalty',
        staging_list: [],
        production_list: [],
        showicon: false,
        option_selected: true
      }]
    } else {
      this.setPayment();
    }
  }

  hidePayAtCounter() {
    this.paymentTypes = this.defaultPaymentTypes.filter(x => x.type !== 'payatcounter');
  }



  customSearchFn(term: string, item: any) {
    return true;
  }


  closeLoading() {
    let temp = this;
    setTimeout(() => {
      temp.ecomservice.commonLoading.show = false;
      temp.ecomservice.loadingPage.loading = false;
    }, 5000);
  }

  // Close loyalty Pop-up
  closeLoyalty() {
    this.modalRefLoyalty.hide();
  }



  // component initialize and load the required data
  async ngOnInit() {
    document.addEventListener('visibilitychange', this.visibilityHandler);
    this.showMessageAfter1Min = false;
    window.addEventListener('pageshow', (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload();
      }
    });

    this.initForm();
    this.paynowclickeddisable = false;
    if (this.webstorage.sessionSt_user_order_reference) {

      const localData = this.webstorage.sessionSt_user_order_reference;
      if (localData.type === "DuitNow") {
        this.inquiryMessage = "";
        let endTime = localStorage.getItem(this.countdownKey);
        if (!endTime) {
          const newEndTime = Date.now() + 1 * 60 * 1000; // 3 mins
          localStorage.setItem('countdown_end_time', newEndTime.toString());
          endTime = newEndTime.toString();
        }
        if (endTime) {
          this.showMessageAfter1Min = true;
          this.startCountdown(parseInt(endTime));
          this.qrImageSrc = localData.Qr_Code;
          this.modalQrPaymentRef = this.modalService.show(this.qrPayment, {
            animated: true,
            class: 'modal-dialog-centered modal-sm modal-loyalty-payment',
            ignoreBackdropClick: true,
            keyboard: false
          });
          this.requestId = localData.referenceNumber;
          this.qrDuitNowData = localData.qrDuitNowData;
          await this.startPollingInquiry();
        } else {
          localStorage.removeItem(this.countdownKey);
        }

      }
      else {
        this.isLoading = true;
        this.customer_order = localData.order_reference;
        this.settingService.setCompanySetting(localData.company_setting);
        this.settingService.setUserSerivce(localData.user_service);
        this.settingService.setCompanySetting(localData.company_setting);
        this.settingService.setLocationSetting(localData.location_setting);
        this.settingService.setUserInfo(localData.user_info);

        this.modalRef = this.modalService.show(this.paymentfailure, {
          animated: true,
          class: 'modal-dialog-centered modal-sm modal-loyalty-payment',
          ignoreBackdropClick: true,
          keyboard: false
        });

        const response = await this.ecomservice.httpPost(EcomNetworkUtils.POST_ORDER_PAYMENT_STATUS, this.customer_order, '', false, false).toPromise();
        this.isLoading = false;
        const orderRes = response.listValue;
        if (response && orderRes) {
          this.paymentResponse = "Payment is unsuccessful.";
          if (orderRes.status === "SUCCESS") {
            this.paymentResponse = orderRes.description;
            this.webstorage.sessionSt_user_order_reference = null;
            this.router.navigate(['status-dinein'], { queryParams: { companyId: response.listValue.companyId, serviceId: response.listValue.oodcdr_pkid } });
            this.paymentDone = true;
            setTimeout(() => {
              this.modalRef.hide();
            }, 5000);
            return;
          }

        }
      }
    }

    if (!this.locationSelected) {
      this.modalRef = this.modalService.show(this.sessionEnded, {
        animated: true,
        class: 'modal-dialog-centered modal-sm modal-loyalty-payment',
        ignoreBackdropClick: true,
        keyboard: false
      });
      this.router.navigate(['home']);
    }
    //as per discussion with sir we need to hide dine-in word incase of storeQR code
    if (this.webstorage.sessionSt_qrcode_type && this.webstorage.sessionSt_qrcode_type === 'QRSTORE') {
      this.IsLocationQRCode = true;
    }
    this.clickCount = 0;

    this.userServiceBase = this.settingService.getUserSerivce();

    // check for checkout expired?
    // if (this.userServiceBase && this.userServiceBase.serviceCheckoutStartedAt
    //   && !this.webstorage.sessionSt_user_order_reference
    // ) {
    //   let date1 = new Date().getTime();
    //   let date2 = new Date(this.userServiceBase.serviceCheckoutStartedAt).getTime();
    //   let time = date1 - date2;  //msec
    //   let minutesDiff = Math.floor(time / 60000);
    //   minutesDiff = Number(minutesDiff.toFixed(0));
    //   let checkoutExpireInMins = Number(this.ecomservice.GetOlarConfigValue('checkoutexpiryInMins'));
    //   if (minutesDiff >= checkoutExpireInMins || NaN) {
    //     this.webstorage.sessionSt_user_order_reference = null;
    //     this.sessionModalRef = this.modalService.show(this.sessionExpired, this.configsessionExpired);
    //   } else {
    //     date2 = new Date(this.userServiceBase.serviceCartStarteddAt).getTime();
    //     let time = date1 - date2;  //msec
    //     let minutesDiff = Math.floor(time / 60000);
    //     minutesDiff = Number(minutesDiff.toFixed(0));
    //     let cartExpireInMins = Number(this.ecomservice.GetOlarConfigValue('cartexpiryInMins'));
    //     if (minutesDiff >= cartExpireInMins || NaN) {
    //       this.webstorage.sessionSt_user_order_reference = null;
    //       this.sessionModalRef = this.modalService.show(this.sessionExpired, this.configsessionExpired);
    //     }
    //   }
    // }

    // if (!this.webstorage.sessionSt_is_session_valid) {
    //   this.router.navigate(['home']);
    // }

    this.usertoken = (this.cookie.cookie_authtoken && this.webstorage.localSt_user_id) ? true : false;
    //this.selectCountyCode();
    if (this.webstorage.sessionSt_frompage && this.webstorage.sessionSt_frompage === 'status') {
      this.router.navigate(['home']);
    } else {
      this.LoadPage();
    }
    this.closeLoading();
  }
  private visibilityHandler = async () => {

    if (document.visibilityState === 'visible') {
      console.log('User back to page.');
      const localData = this.webstorage.sessionSt_user_order_reference;
      if (localData && localData.type === "DuitNow" && !this.isLoading) {
        await this.startPollingInquiry();
      }


    }
  };

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
    document.removeEventListener('visibilitychange', this.visibilityHandler);
  }

  handleRetryDuit() {
    //sessionSt_user_order_reference
  }
  onPaymentCloseClick() {
    this.webstorage.sessionSt_user_order_reference = null;
    clearInterval(this.interval);
    if (this.modalRef) this.modalRef.hide();
    if (this.modalQrPaymentRef) this.modalQrPaymentRef.hide();
    this.paynowclickeddisable = false;
    this.stopPolling();
    this.cancel$.next();

  }
  showConfirmCloseQrPayment() {
    if (this.displayTime === '00:00' || !this.qrImageSrc) {
      this.onPaymentCloseClick();
      return;
    }

    this.modalRef = this.modalService.show(this.cancelQrPayment, {
      animated: true,
      class: 'modal-dialog-centered modal-sm modal-loyalty-payment',
      ignoreBackdropClick: true,
      keyboard: false
    });
  }

  closeQrPayment() {
    this.webstorage.sessionSt_user_order_reference = null;
    clearInterval(this.interval);
    if (this.modalQrPaymentRef) this.modalQrPaymentRef.hide();
    this.paynowclickeddisable = false;
    this.stopPolling();
  }

  closeCancelQrPayment() {
    this.modalRef.hide();
  }
  startCountdown(endTime: number): void {
    this.updateDisplay(endTime);
    this.interval = setInterval(() => {
      this.updateDisplay(endTime);
    }, 1000);
  }

  updateDisplay(endTime: number): void {
    const now = Date.now();
    const diff = Math.max(0, Math.floor((endTime - now) / 1000)); // seconds remaining

    if (diff <= 0) {
      this.displayTime = '00:00';
      clearInterval(this.interval);
      localStorage.removeItem(this.countdownKey);
      return;
    }

    const minutes = Math.floor(diff / 60);
    const seconds = diff % 60;
    this.displayTime = `${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  pad(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  saveUrl(companyId, orderPkid) {
    const lst = this.webstorage.sessionSt_status_companyids && this.webstorage.sessionSt_status_companyids.length ? this.webstorage.sessionSt_status_companyids : [];
    const model = {
      companyId: companyId,
      serviceId: orderPkid,
      index: lst.length + 1
    }
    //const lst = this.webstorage.sessionSt_status_companyids && this.webstorage.sessionSt_status_companyids.length ? this.webstorage.sessionSt_status_companyids : [];
    lst.push(model);

    const createKey = (obj) => `${obj.companyId}-${obj.serviceId}`;

    const seen = new Set();
    const distinctArray = lst.filter(item => {
      const key = createKey(item);
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    }).sort((a, b) => b.index - a.index);

    this.webstorage.sessionSt_status_companyids = distinctArray;
  }
  async manualInquiryQr() {
    this.isManual = true;
    if (this.isLoading) return;
    this.showMessageAfter1Min = true;
    const data = this.qrDuitNowData;
    const model = {
      amount: data.Amount,
      currency: data.Currency,
      device_id: data.Device_Id,
      entry_mode: data.Entry_Mode,
      merchant_id: data.Merchant_Id,
      original_transaction_reference_number: data.Transaction_Reference_Number,
      qr_code: data.Qr_Code,
      request_id: this.requestId,
      scheme: "DN",
      transaction_datetime: data.Transaction_Datetime
    }

    this.isLoading = true;
    const res = await this.ecomservice.httpPost(EcomNetworkUtils.POST_ORDER_INQUIRY_QR_PAYMENT, model, '', true, true).toPromise();
    this.isLoading = false;
    this.ecomservice.commonLoading.show = false;
    this.ecomservice.loadingPage.loading = false;
    this.isManual = false;

    if (res) {
      const orderRes = res.listValue;
      if (res.isSuccess && res.listValue.status === "SUCCESS") {

        this.pollingActive = false;
        this.paymentResponse = orderRes.description;
        this.webstorage.sessionSt_user_order_reference = null;
        this.paymentDone = true;
        await this.delay(2000);
        this.onPaymentCloseClick();
        if (res.listValue.companyId && res.listValue.oodcdr_pkid) {
          this.saveUrl(res.listValue.companyId, res.listValue.oodcdr_pkid);
        }
        alert(`Payment successful!\nYour ticket number is: ${res.listValue.order_number}`);
        this.router.navigate(['status-dinein'], { queryParams: { companyId: res.listValue.companyId, serviceId: res.listValue.oodcdr_pkid } });

      }
      if (!res.isSuccess) {
        // "Expired QR Code"
        if (orderRes.status === "70") {
          this.bankResult = orderRes.message;
          this.inquiryMessage = "Sorry your payment was unsuccessful";
          this.displayTime = '00:00';
          localStorage.removeItem(this.countdownKey);
          this.stopPolling();
          clearInterval(this.interval);
        }
      }
    }

  }

  async inquiryQr() {
    const d = this.qrDuitNowData;
    const model = {
      amount: d.Amount,
      currency: d.Currency,
      device_id: d.Device_Id,
      entry_mode: d.Entry_Mode,
      merchant_id: d.Merchant_Id,
      original_transaction_reference_number: d.Transaction_Reference_Number,
      qr_code: d.Qr_Code,
      request_id: this.requestId,
      scheme: 'DN',
      transaction_datetime: d.Transaction_Datetime
    };

    this.isLoading = true;
    try {
      const res = await this.ecomservice.httpPost(
        EcomNetworkUtils.POST_ORDER_INQUIRY_QR_PAYMENT,
        model, '', false, false
      ).pipe(
        tap(() => console.log('[inquiryQr] firing request...')),
        takeUntil(this.cancel$),  // cancel in‑flight khi this.cancel$.next()
        first(),                 // lấy giá trị đầu tiên rồi complete
        finalize(() => this.isLoading = false)
      ).toPromise();              // ✅ RxJS 6
      return res;                 // có thể là any hoặc kiểu DTO bạn khai báo
    } catch (err) {
      // Nếu bị cancel TRƯỚC khi có emission, first() sẽ ném EmptyError
      console.log('[inquiryQr] error/canceled:', err);
      return null;
    } finally {
      // reset
      this.isLoading = false;
    }
  }
  async getQRPayment(referenceNumber: string, localData) {
    this.qrImageSrc = "";
    this.modalQrPaymentRef = this.modalService.show(this.qrPayment, {
      animated: true,
      class: 'modal-dialog-centered modal-sm modal-loyalty-payment',
      ignoreBackdropClick: true,
      keyboard: false
    });
    const amount = Number((this.amountToPay - this.loyaltyAmount).toFixed(2));
    const model = {
      request_id: referenceNumber,
      amount: amount
    }

    this.requestId = referenceNumber;
    const response = await this.ecomservice.httpPost(EcomNetworkUtils.POST_ORDER_QR_PAYMENT, model, '', false, false).toPromise();
    this.ecomservice.commonLoading.show = false;
    this.ecomservice.loadingPage.loading = false;
    if (response.isSuccess && response.listValue) {
      this.qrDuitNowData = response.listValue;

      if (!response.listValue.Qr_Code) return;

      QRCode.toDataURL(response.listValue.Qr_Code, { errorCorrectionLevel: 'M', width: 220 })
        .then(url => {
          this.qrImageSrc = url;
          if (!this.qrImageSrc) {
            return;
          }
          // Get QR starts countdown
          //const newEndTime = Date.now() + 3 * 1000;
          const newEndTime = Date.now() + 3 * 60 * 1000; // 3 mins
          localStorage.setItem('countdown_end_time', newEndTime.toString());
          localData.Qr_Code = url;
          localData.referenceNumber = referenceNumber;
          localData.qrDuitNowData = this.qrDuitNowData;
          this.webstorage.sessionSt_user_order_reference = localData;

          setTimeout(() => {
            this.showMessageAfter1Min = true;
          }, 60000);
          this.startCountdown(newEndTime);
          this.startPollingInquiry();
        }).catch(console.error);


    }
  }

  private cancel$ = new Subject<void>();
  private pollingActive = false;

  async startPollingInquiry(): Promise<void> {
    try {
      this.inquiryMessage = "";
      this.pollingActive = true;
      this.bankResult = "";

      const endTime = localStorage.getItem(this.countdownKey);
      this.inquiryCount = 0;
      while (this.pollingActive) {
        if (this.inquiryCount === 0) {
          this.inquiryMessage = "Please wait and stay on this page, while we complete processing your payment​";
        } else {
          this.inquiryMessage = "We are still waiting response from Bank and will be very soon now";
        }
        if (!this.isLoading) {
          const res = await this.inquiryQr();
          if (res) {
            const orderRes = res.listValue;
            if (res.isSuccess && res.listValue && res.listValue.status === "SUCCESS") {

              this.pollingActive = false;
              this.paymentResponse = orderRes.description;
              this.webstorage.sessionSt_user_order_reference = null;
              this.paymentDone = true;
              await this.delay(2000);
              this.onPaymentCloseClick();
              if (res.listValue.companyId && res.listValue.oodcdr_pkid) {
                this.saveUrl(res.listValue.companyId, res.listValue.oodcdr_pkid);
              }
              alert(`Payment successful!\nYour ticket number is: ${res.listValue.order_number}`);
              this.router.navigate(['status-dinein'], { queryParams: { companyId: res.listValue.companyId, serviceId: res.listValue.oodcdr_pkid } });

              break;
            }
            if (!res.isSuccess) {
              // "Expired QR Code"
              if (orderRes && orderRes.status === "70") {
                this.bankResult = orderRes.message;
                this.inquiryMessage = "Sorry your payment was unsuccessful";
                this.displayTime = '00:00';
                localStorage.removeItem(this.countdownKey);
                this.stopPolling();
                clearInterval(this.interval);
                break;
              }
            }
          }

        }
        else {
          console.log(`Waiting for response from Bank, skipping duplicate call.`);
        }
        console.log(`Retrying in 5 seconds...`);
        // Waiting for 5 seconds
        this.inquiryCount++;
        await this.delay(5000);
      }

      // if (!this.isPaymentSuccessLast) {
      //   this.onTimeout(); // xử lý nếu hết 3 phút mà chưa thanh toán
      // }
    } catch (err) {
      console.log('Error in startPollingInquiry:', err);
    }
  }
  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  stopPolling(): void {
    this.pollingActive = false;
  }

  LoadPage() {
    this.paynowclickeddisable = false;
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
        if (response.isSuccess) {
          if (!this.webstorage.localSt_client_id) {
            this.webstorage.localSt_client_id = response.listValue.oock_client_id;
          }
          // store public key
          this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
          this.initPage();

        }
      });
    } else {
      this.initPage();
    }
  }


  initPage() {
    this.qrCodeScanned = this.webstorage.sessionSt_qr_code_scanned === null ? false : this.webstorage.sessionSt_qr_code_scanned;
    this.url = this.router.url;
    this.webstorage.sessionSt_qr_scan_current_page = this.router.url;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    this.locationSelected = this.settingService.getCompanySetting();
    if (!this.locationSelected) {
      this.modalRef = this.modalService.show(this.sessionEnded, {
        animated: true,
        class: 'modal-dialog-centered modal-sm modal-loyalty-payment',
        ignoreBackdropClick: true,
        keyboard: false
      });
      this.router.navigate(['home']);
    } else {
      //this.serviceType = this.webstorage.sessionSt_service_type;
      //this.settings = this.webstorage.sessionSt_settings;
      this.locationSelected = this.settingService.getCompanySetting();
      //this.distance = Number(this.locationSelected.distance);
      // this.locationDetails = this.webstorage.sessionSt_orderlocation_details;
      this.userServiceBase = this.settingService.getUserSerivce();




      let serviceActiveId = this.webstorage.sessionSt_service_active_id;
      if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
        serviceActiveId = 1;
      }
      //let userStoreIndex = -1;
      // const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
      //   //userStoreIndex = index;
      //   return obj.locationPkid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid && !obj.serviceCompleted && obj.serviceType === this.serviceType;
      // });
      // this.userSelectedStore = selectedStore;
      // should check null this.userSelectedStore
      this.amountToPay = this.userSelectedStore.storeCart.orderTotal;
      this.amountToPay = this.amountToPay < 0 ? 0 : this.amountToPay;
      this.balanceToPay = this.amountToPay;
      this.amountToPayFromCart = (this.userSelectedStore.storeCart.orderTotal
        + this.userSelectedStore.storeCart.orderDeliveryTax
        + this.userSelectedStore.storeCart.orderDeliveryCharge
        + this.userSelectedStore.storeCart.orderServiceCharge)
        - this.userSelectedStore.storeCart.orderPickupCashback
        - this.userSelectedStore.storeCart.orderDiscountReferral
        - this.userSelectedStore.storeCart.voucherAmount
        - this.userSelectedStore.storeCart.orderCashbackOlar;
      this.amountToPayFromCart = this.amountToPayFromCart < 0 ? 0 : this.amountToPayFromCart;
      this.setPayment();
      this.orderDatetime = this.getOrderDatetimeFormat(this.userSelectedStore.serviceDatetime);
      //clear the voucher if saved previously
      // if (selectedStore) {
      //   this.userSelectedStore.storeCart.voucherAmount = 0;
      //   this.userSelectedStore.storeCart.voucher = null;
      // }
      if (this.usertoken) {
        //this.checkoutform.controls['mobile'].disable();
      }
      this.setValidators();

      this.username = this.webstorage.localSt_name ? this.webstorage.localSt_name : this.userServiceBase.userName;
      this.usercontact = this.webstorage.localSt_contact ? this.webstorage.localSt_contact : this.userServiceBase.userMobile;

      if (this.userServiceBase.userDialCode) {
        this.selectedCountryISO = this.userServiceBase.userDialCode.toLocaleLowerCase();
      }
      if (this.username) {
        this.checkoutform.controls.name.setValue(this.username);
      }
      if (this.usercontact) {
        this.checkoutform.controls.mobile.setValue(this.usercontact);
      }
      if (this.userServiceBase.userDialCode) {
        this.checkoutform.controls.countryCode.setValue(this.userServiceBase.userDialCode);
      }

      this.checkoutform.controls.userAddressSearch.setValue(this.cookie.cookie_address_place_id);
      this.checkoutform.controls.landMark.setValue(this.ecomservice.htmlUtil.textTruncate(this.userServiceBase.landMark, 25));
      this.checkoutform.controls.userCity.setValue(this.cookie.cookie_usercity);
      this.checkoutform.controls.userPostCode.setValue(this.cookie.cookie_pincode);

    }

    if (this.webstorage.sessionSt_location_selected) {
      var encoded = Base64.encode(this.webstorage.sessionSt_location_selected.oocls_company_id);
      this.location.replaceState(this.location.path(), '?webcompanyid=' + encoded);
    }

  }

  initForm() {

    this.checkoutform = this.formBuilder.group({
      locationGuid: [],
      locationName: [],
      locationAddress: [''],
      date: [''],
      time: [''],
      table: [''],
      //name: ['', Validators.compose([Validators.required])],
      name: ['Guest'],
      countryCode: ['MY'],
      //mobile: ['', Validators.compose([Validators.required])],
      mobile: ['1111111111'],
      areaSelected: [],
      tableSelected: [],
      allow_dinein: [],
      allow_collection: [],
      allow_delivery: [],
      allow_reservation: [],
      userAddressSearch: [],
      landMark: [],
      userCity: [],
      userPostCode: [],
      userDistance: [],
      operation_dine_in_start: [],
      operation_dine_in_end: [],
      operation_delivery_start: [],
      operation_delivery_end: [],
      operation_collection_start: [],
      operation_collection_end: [],
      savedAddress: [],
      deliverynotes: [],
      paxdetailsList: this.formBuilder.array([]),
      pax: [],
      sitting_area: []
    });

    this.customerDetailsForm = this.formBuilder.group({
      name: ['', Validators.compose([Validators.required, Validators.pattern(/[\S]/g)])],
      email: ['', Validators.compose([Validators.required, EcomValidator.emailValidator, Validators.pattern(/[\S]/g)])],
      contact: ['', Validators.compose([Validators.required, Validators.pattern(/[\S]/g)])]
    });

    this.rhPaymentForm = this.formBuilder.group({
      Revpay_Merchant_ID: [],
      Payment_ID: [],
      Bank_Code: [],
      Reference_Number: [],
      Amount: [],
      Currency: [],
      Transaction_Description: [],
      Customer_Name: [],
      Customer_Email: [],
      Customer_Contact: [],
      Customer_IP: [],
      Installment_Plan: [],
      Installment_Term: [],
      Key_Index: [],
      Signature: [],
      Return_URL: [],
      Promo_Code: [],
      Customization: [],
      Backend_URL: []
    });

    this.signupform = this.formBuilder.group({
      mobile: ['', Validators.compose([Validators.required])],
    });
  }

  isZero(value: number): boolean {
    return Math.abs(value) < 0.005;
  }

  setPayment() {
    const setting = this.settingService.getLocationSetting();
    this.showonlinePayments = true;
    this.paymentTypes = this.defaultPaymentTypes;

    if (
      this.isZero(this.amountToPay) ||
      this.isZero(this.amountToPay - this.loyaltyAmount)
    ) {
      this.paymentTypes = [{
        type: 'loyalty',
        collapsed: true,
        name: 'Loyalty',
        selected: '',
        staging_list: [],
        production_list: [],
        showicon: false,
        option_selected: false
      }];

      return;
    }

    if (this.loyaltyAmount > 0) {
      this.paymentTypes = this.defaultPaymentTypes.filter(x => x.type !== 'payatcounter');
      //return;
    }

    if (this.QRCodeType === QRType.Table) {
      this.showPayAtCounter = setting.oosrcs_cash_on_table_qrcode;

      if (setting.table_qr_paymentmode === 'O') {
        this.showPayAtCounter = true;
        this.paymentTypes = this.defaultPaymentTypes.filter(x => x.type === 'payatcounter');
        this.showonlinePayments = false;
      }

    } else if (this.QRCodeType === QRType.Store) {
      this.showPayAtCounter = setting.oosrcs_cash_on_store_qrcode;
      if (setting.store_qr_paymentmode === 'O') {
        this.showPayAtCounter = true;
        this.paymentTypes = this.defaultPaymentTypes.filter(x => x.type === 'payatcounter');
        this.showonlinePayments = false;
      }
    }


    if (this.userSelectedStore.storeCart.orderItems.some(item =>
      item.hasReward) || this.userServiceBase.order_level_reward) {
      this.paymentTypes = this.defaultPaymentTypes.filter(x => x.type !== 'payatcounter');
    }
    if (!this.showPayAtCounter) {
      this.paymentTypes = this.defaultPaymentTypes.filter(x => x.type !== 'payatcounter');
    }


    //if qrpayment mode is menu then user can view menu only
    // if (this.webstorage.sessionSt_qr_paymentmode) {
    //   if (setting.table_qr_paymentmode === 'O') {
    //     this.showonlinePayments = false;
    //   } else {
    //     this.showonlinePayments = true;
    //   }
    // }
    //store qr code need to show online payments
    // if (this.payatCounter === false && this.qrCodeScanned === true) {
    //   this.showonlinePayments = true;
    // }

    if (this.showonlinePayments && this.userServiceBase.hasUnpaidOrder && this.webstorage.sessionSt_status_serviceid) {
      this.paymentTypes = this.defaultPaymentTypes.filter(x => x.type === 'payatcounter');
    }

    if ((this.QRCodeType === QRType.Table && setting.table_qr_paymentmode === "M") || (this.QRCodeType === QRType.Store && setting.store_qr_paymentmode === 'M')) {
      this.toastService.show('The menu is available in view-only mode!');

      this.paymentTypes = [];
      this.showonlinePayments = false;
    }

  }


  getOrderDatetimeFormat(orderDateTime): any {
    let orderDateTimeArray = orderDateTime.split(' ');
    let datetime = orderDateTimeArray[1] + ' ' + orderDateTimeArray[2];
    let today = new Date();
    let day = today.getDate() + '';
    day = this.checkZero(day)
    let month = (today.getMonth() + 1) + '';
    let year = today.getFullYear() + '';
    let hour = today.getHours() + '';
    let minutes = today.getMinutes() + '';
    let seconds = today.getSeconds() + '';

    let orderDateArray = orderDateTimeArray[0].split('-');
    const monthNames = ["Jan", "Feb", "March", "April", "May", "June",
      "July", "Aug", "Sept", "Oct", "Nov", "Dec"
    ];
    let monthname = monthNames[Number(orderDateArray[1]) - 1];
    if (day !== orderDateArray[2]) {
      day = this.checkZero(day);
      datetime = datetime + ',' + orderDateArray[2] + ' ' + monthname;
    } else {
      datetime = datetime + ', Today';
    }
    return datetime;
  }

  // Method to append zero
  checkZero(data) {
    if (data.length === 1) {
      data = '0' + data;
    }
    return data;
  }

  // Method to get the dateformat
  getDateFormat(today: Date) {
    let day = today.getDate() + '';
    let month = (today.getMonth() + 1) + '';
    let year = today.getFullYear() + '';
    let hour = today.getHours() + '';
    let minutes = today.getMinutes() + '';
    let seconds = today.getSeconds() + '';

    day = this.checkZero(day);
    month = this.checkZero(month);
    year = this.checkZero(year);
    hour = this.checkZero(hour);
    minutes = this.checkZero(minutes);
    seconds = this.checkZero(seconds);
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
  }

  // Method to set the validators
  setValidators() {
    this.checkoutform.controls.userAddressSearch.reset();
    this.checkoutform.controls.userAddressSearch.clearValidators();
    this.checkoutform.controls.landMark.reset();
    this.checkoutform.controls.landMark.clearValidators();
    this.checkoutform.controls.deliverynotes.reset();
    this.checkoutform.controls.deliverynotes.clearValidators();
    this.checkoutform.controls.userCity.reset();
    this.checkoutform.controls.userCity.clearValidators();
    this.checkoutform.controls.userPostCode.reset();
    this.checkoutform.controls.userPostCode.clearValidators();

    this.checkoutform.controls.pax.reset();
    this.checkoutform.controls.pax.clearValidators();
    this.checkoutform.controls.sitting_area.reset();
    this.checkoutform.controls.sitting_area.clearValidators();

    this.checkoutform.updateValueAndValidity();
    switch (this.serviceType) {
      case 'DINE_IN':
        //this.checkoutform.controls.pax.setValidators(Validators.compose([Validators.required, Validators.min(1)]));
        if (this.areaList.length > 0) {
          this.checkoutform.controls.sitting_area.enable();
          this.checkoutform.controls.sitting_area.setValidators(Validators.compose([Validators.required]));
        } else {
          this.checkoutform.controls.sitting_area.disable();
        }
        break;
      case 'COLLECTION':
        break;
      case 'DELIVERY':

        break;
    }
    this.checkoutform.updateValueAndValidity();
  }

  // Method to handle the sign in click event


  // Method to handle the back button click
  onBackClick() {
    this.router.navigate(['cart', "items"]);
  }

  // Method to generate orderid
  getOrderID() {
    // Company, location, day, month, year,hour,minutes,seconds,milliseconds
    const day = new Date().getDate();
    const month = new Date().getMonth() + 1;
    // const yearlength = new Date().getFullYear().toString().length;
    const year = new Date().getFullYear().toString().substr(2);
    const hour = new Date().getHours();
    const minute = new Date().getMinutes();
    const second = new Date().getSeconds();
    const milliseconds = new Date().getMilliseconds();
    const orderId = '' + day + month + year + hour + minute + second + milliseconds;
    return orderId;
  }



  // Method to handle the alert close event
  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = [];
  }

  onSignUpNowClick() {
    if (this.signupform.invalid) {
      Object.keys(this.signupform.controls).forEach(key => {
        this.signupform.get(key).markAsDirty();
      });
      return;
    } else {
      // clear the already logged in details
      this.webstorage.localSt_user_id = undefined;
      this.cookie.delete_cookie('authtoken');
      this.modalRef.hide();
      //$('.modal').css({"display": "none"});
      this.webstorage.sessionSt_frompage = 'checkout';
      this.router.navigate(['login'], { queryParams: { usermob: this.signupform.controls['mobile'].value.number } });
    }
  }

  // Method to handle the modal pop close event
  onCloseClick() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
  }

  scrollTop() {
    $('html, body').animate({
      scrollTop: $('#checkout').offset().top
    }, 100);
  }

  // QR order phone verify
  modalRefQROrderPhoneVerify: BsModalRef;
  @ViewChild('displayQROrderPhoneVerify', { static: true }) displayQROrderPhoneVerify: ElementRef;
  configQROrderPhoneVerify = {
    animated: true,
    class: 'modal-dialog-centered modal-sm modal-loyalty-payment',
    ignoreBackdropClick: false,
    keyboard: true
  };
  qrorder_phone_number = '';
  qrorder_country_code = '';
  showOtp = false;
  public userOTPForm: FormGroup;
  isOtpVerified = false;
  timerOn = false;
  sentOTP = false;
  errorMessage = '';
  userId = '';
  resendOTP = false;
  timeoutFunc: any;
  register = false;
  buttonClicked = false;
  paymenttype_clicked = '';
  OTP_type = '';
  screen_otp = '';

  onCloseQROrderPhoneVerifyClick() {
    this.modalRefQROrderPhoneVerify.hide();
  }

  onQROrderPhoneVerifyClick() {
    this.errorMessage = '';
    this.showOtp = false;
    this.resendOTP = false;
    if (!this.userOTPForm.value.mobile || !this.userOTPForm.value.mobile.internationalNumber) {
      this.errorMessage = 'Enter mobile number';
      return;
    } else {
      // check only for mobile number here
      const controls = this.userOTPForm.controls;
      let invalid = false;
      for (const name in controls) {
        if (name === 'mobile' && controls[name].invalid) {
          controls[name].markAsDirty();
          invalid = true;
        }
      }
      if (invalid) {
        this.errorMessage = 'Invalid mobile number';
        return;
      } else {
        this.buttonClicked = true;
        const input = {
          ooc_country_dial_code: this.ecomservice.encryptWithKey(this.userOTPForm.value.mobile.countryCode),
          ooc_customer_mobile: this.ecomservice.encryptWithKey(this.userOTPForm.value.mobile.number),
          customer_key: this.webstorage.localSt_olar_key,
          customer_client_key: this.webstorage.localSt_client_id
        };
        this.ecomservice.httpPost(EcomNetworkUtils.POST_QR_USER_GET_OTP, input, '', true).subscribe(response => {
          if (response.isSuccess) {
            this.resendOTP = false;
            this.userId = response.listValue;
            this.showOtp = true;
            this.sentOTP = true;
            this.timerOn = true;
            this.timer(119);
            this.OTP_type = response.msg;
            if (this.OTP_type === 'SCREEN_OTP') {
              this.screen_otp = atob(response.value);
            }
          } else {
            this.buttonClicked = false;
            this.errorMessage = response.msg;
          }
        });
      }
    }
  }

  onClickPrivacy() {
    window.open('./assets/media/Olarme_policy.pdf', '_blank');
  }

  // Method to resend the OTP to user mobile number
  onresendOTPClick() {
    this.errorMessage = undefined;
    this.showOtp = false;
    if (!this.userOTPForm.value.mobile || !this.userOTPForm.value.mobile.internationalNumber) {
      this.errorMessage = 'Enter mobile number';
      return;
    } else {
      // check only for mobile number here
      const controls = this.userOTPForm.controls;
      let invalid = false;
      for (const name in controls) {
        if (name === 'mobile' && controls[name].invalid) {
          controls[name].markAsDirty();
          invalid = true;
        }
      }
      if (invalid) {
        this.errorMessage = 'Invalid mobile number';
        return;
      } else {
        const input = {
          ooc_country_dial_code: this.ecomservice.encryptWithKey(this.userOTPForm.value.mobile.countryCode),
          ooc_customer_mobile: this.ecomservice.encryptWithKey(this.userOTPForm.value.mobile.number),
          customer_key: this.webstorage.localSt_olar_key,
          customer_client_key: this.webstorage.localSt_client_id
        };
        this.resendOTP = false;
        this.userId = '';
        this.showOtp = true;
        this.timerOn = true;
        this.ecomservice.httpPost(EcomNetworkUtils.POST_QR_USER_GET_OTP, input, '', true).subscribe(response => {
          if (response.isSuccess) {
            this.resendOTP = false;
            this.userId = response.listValue;
            this.showOtp = true;
            this.timerOn = true;
            this.timer(119);
            this.OTP_type = response.msg;
            if (this.OTP_type === 'SCREEN_OTP') {
              this.screen_otp = atob(response.value);
            }
          } else {
            this.errorMessage = response.msg;
          }
        });
      }
    }
  }

  // Timer for OTP
  timer(remaining) {
    let m = Math.floor(remaining / 60);
    let s = remaining % 60;
    m = m < 10 ? 0 + m : m;
    s = s < 10 ? 0 + s : s;
    if (document.getElementById('timer')) {
      document.getElementById('timer').innerHTML = ('0' + m).slice(-2) + ' : ' + ('0' + s).slice(-2);
    }
    remaining -= 1;
    if (remaining >= 0 && this.timerOn) {
      let temp = this;
      this.timeoutFunc = setTimeout(function () {
        temp.timer(remaining);
      }, 1000);
      return;
    }
    if (!this.timerOn) {
      // Do validate stuff here
      return;
    }
    this.timerOn = false;
    this.resendOTP = true;
    // Do timeout stuff here
  }

  // On Focus event of Pin
  onFocusEvent(index) {
    for (let item = 1; item < index; item++) {
      const currentElement = (<HTMLInputElement>document.getElementById('pin' + item));
      if (!currentElement.value) {
        currentElement.focus();
        break;
      }
    }
  }

  // OTP Key Up event
  otp_request_sent = false;
  onKeyUpEvent(index, event) {
    this.otp_request_sent = false;
    var allowedValue = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]
    if (allowedValue.indexOf(event.target.value) === -1) {
      event.target.value = '';
      return false;
    }
    const pin = this.userOTPForm.controls['pin1'].value.toString()
      + this.userOTPForm.controls['pin2'].value.toString()
      + this.userOTPForm.controls['pin3'].value.toString() +
      this.userOTPForm.controls['pin4'].value.toString();
    if (pin.length === 4 && this.otp_request_sent === false) {
      const otpinput = {
        ooc_guid: this.userId,
        otp: this.ecomservice.encryptWithKey(pin),
        customer_key: this.webstorage.localSt_olar_key,
        customer_client_key: this.webstorage.localSt_client_id
      };
      const url = EcomNetworkUtils.POST_QR_USER_VERIFY_OTP;
      this.otp_request_sent = true;
      this.ecomservice.httpPost(url, otpinput, '', true).subscribe((response) => {
        if (response.isSuccess) {
          // if (this.OTP_type === 'SCREEN_OTP') {
          //   this.ContinuePayment(this.paymenttype_clicked, false);
          // } else {
          //   this.userId = response.listValue;
          //   this.isOtpVerified = true;
          //   this.errorMessage = undefined;
          //   this.buttonClicked = false;
          // }
          //update phone number
          this.userServiceBase.userDialCode = this.userOTPForm.value.mobile.countryCode;
          this.userServiceBase.userMobile = this.userOTPForm.value.mobile.number;
          this.webstorage.localSt_contact = this.userOTPForm.value.mobile.number;

          this.checkoutform.controls['countryCode'].setValue(this.userOTPForm.value.mobile.countryCode);
          this.checkoutform.controls['mobile'].setValue(this.userOTPForm.value.mobile.number);

          this.ContinuePayment(this.paymenttype_clicked, false);
        } else {
          this.otp_request_sent = false;
          this.errorMessage = 'Invalid otp';
        }
      });
    } else {
      const eventCode = event.which || event.keyCode;
      if ((<HTMLInputElement>document.getElementById('pin' + index)).value.length === 1) {
        if (index !== 4) {
          document.getElementById('pin' + (index + 1)).focus();
        } else {
          document.getElementById('pin' + index).blur();
          const pin = this.userOTPForm.controls['pin1'].value.toString()
            + this.userOTPForm.controls['pin2'].value.toString()
            + this.userOTPForm.controls['pin3'].value.toString()
            + this.userOTPForm.controls['pin4'].value.toString();

        }
      }
      if (eventCode === 8 && index !== 1) {
        document.getElementById('pin' + (index - 1)).focus();
      }
    }
  }

  QRPhoneVerifyDisplay() {
    this.modalRefQROrderPhoneVerify = this.modalService.show(this.displayQROrderPhoneVerify, this.configQROrderPhoneVerify);
    this.userOTPForm = this.formBuilder.group({
      pin1: [''],
      pin2: [''],
      pin3: [''],
      pin4: [''],
      mobile: ['', Validators.compose([Validators.required])],
      password: []
    });
    this.qrorder_phone_number = '';
    this.qrorder_country_code = '';
    this.showOtp = false;

    this.isOtpVerified = false;
    this.timerOn = false;
    this.sentOTP = false;
    this.errorMessage = '';
    this.userId = '';
    this.resendOTP = false;
    this.register = false;
    this.buttonClicked = false;
    this.OTP_type = '';
    this.screen_otp = '';
  }

  onSetupClick() {
    this.register = true;
  }

  onSkipContinueClick() {
    this.modalRefQROrderPhoneVerify.hide();
    this.ContinuePayment(this.paymenttype_clicked, false);
  }



  onPaymentClick(type, paidbyolars = false) {
    this.onPaymentClick1(type, paidbyolars);
  }
  onPaymentClick1(type, paidbyolars = false) {

    this.clickCount = 1;
    let sessionExpired = false;
    //first check for cart expired?
    // if (this.userServiceBase && this.userServiceBase.serviceCartStarteddAt
    //   && !this.webstorage.sessionSt_user_order_reference
    // ) {
    //   let date1 = new Date().getTime();
    //   let date2 = new Date(this.userServiceBase.serviceCartStarteddAt).getTime();
    //   let time = date1 - date2;  //msec
    //   let minutesDiff = Math.floor(time / 60000);
    //   minutesDiff = Number(minutesDiff.toFixed(0));
    //   let cartExpireInMins = Number(this.ecomservice.GetOlarConfigValue('cartexpiryInMins'));
    //   if (minutesDiff >= cartExpireInMins || NaN) {
    //     this.clickCount = 0;
    //     sessionExpired = true;
    //     this.sessionModalRef = this.modalService.show(this.sessionExpired, this.configsessionExpired);
    //   }
    // } else {
    //   this.clickCount = 0;
    //   sessionExpired = true;
    //   this.sessionModalRef = this.modalService.show(this.sessionExpired, this.configsessionExpired);
    // }
    // // check for checkout expired?
    // if (this.userServiceBase && this.userServiceBase.serviceCheckoutStartedAt) {
    //   let date1 = new Date().getTime();
    //   let date2 = new Date(this.userServiceBase.serviceCheckoutStartedAt).getTime();
    //   let time = date1 - date2;  //msec
    //   let minutesDiff = Math.floor(time / 60000);
    //   minutesDiff = Number(minutesDiff.toFixed(0));
    //   let checkoutExpireInMins = Number(this.ecomservice.GetOlarConfigValue('checkoutexpiryInMins'));
    //   if (minutesDiff >= checkoutExpireInMins || NaN) {
    //     this.clickCount = 0;
    //     sessionExpired = true;
    //     this.sessionModalRef = this.modalService.show(this.sessionExpired, this.configsessionExpired);
    //   }
    // } else {
    //   this.clickCount = 0;
    //   sessionExpired = true;
    //   this.sessionModalRef = this.modalService.show(this.sessionExpired, this.configsessionExpired);
    // }
    if (!sessionExpired) {
      //this.saveUserDeliveryDetailsLocally();
      this.clickEvent = 'SUBMIT';
      if (this.checkoutform.invalid) {
        Object.keys(this.checkoutform.controls).forEach(key => {
          this.checkoutform.get(key).markAsDirty();
        });
        this.alerts = [];
        if ((this.checkoutform.get('landMark').errors && this.checkoutform.get('landMark').errors.pattern)
          || (this.checkoutform.get('deliverynotes').errors && this.checkoutform.get('deliverynotes').errors.pattern)) {
          this.alerts.push({
            type: 'warning',
            msg: 'Please enter valid characters!',
            timeout: 5000,
            isOpen: true
          });
        } else {
          this.alerts.push({
            type: 'warning',
            msg: 'Please enter required fields!',
            timeout: 5000,
            isOpen: true
          });
        }
        this.scrollTop();
        this.clickCount = 0;
        return;
      } else {
        // check if it's dine in qr order and payment type is pay at counter then no login required or else login required
        /*
        * Commented by Harish
        * Description : In qr order if online payment then verify phone number as flow explained by raj sir
        *
        if (this.serviceType === 'DINE_IN' &&
          this.webstorage.sessionSt_qrcode_type &&
          (this.webstorage.sessionSt_qrcode_type === 'QRSTORE' || this.webstorage.sessionSt_qrcode_type === 'QRTABLE') &&
          type !== 'Reserved' &&
          !this.usertoken) {
          this.webstorage.sessionSt_frompage = 'checkout';
          this.router.navigate(['login']);
          return;
        }
        */


        this.paymentModeSelected = type;

        this.ContinuePayment(type, paidbyolars);
      }
    }


  }


  ContinuePayment(type, paidbyolars = false) {
    try {
      this.paymentTypeSelected = type;
      let continuePayment = true;
      let serviceActiveId = this.webstorage.sessionSt_service_active_id;
      if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
        serviceActiveId = 1;
      }
      //let userStoreIndex = -1;
      const selectedStore = this.settingService.getSelectedStore(this.serviceType);
      let paymentAmount = (selectedStore.storeCart.orderTotal +
        selectedStore.storeCart.orderServiceCharge +
        selectedStore.storeCart.orderDeliveryCharge +
        selectedStore.storeCart.orderDeliveryTax)
        -
        (selectedStore.storeCart.orderCashbackOlar +
          selectedStore.storeCart.orderPickupCashback +
          selectedStore.storeCart.voucherAmount +
          selectedStore.storeCart.orderDiscountReferral +
          this.redeemAmount);
      if (paymentAmount <= 0 && this.paymentTypeSelected === 'Olars') {
        if (this.serviceType === 'DINE_IN') {
          this.saveDineIn(this.paymentTypeSelected, paidbyolars);
        } else if (this.serviceType === 'COLLECTION') {
          this.saveCollection(this.paymentTypeSelected, paidbyolars);
        } else if (this.serviceType === 'DELIVERY') {

        }
      } else if (paymentAmount <= 0) {
        if (this.serviceType === 'DINE_IN') {
          this.saveDineIn('Voucher', false, true);
        } else if (this.serviceType === 'COLLECTION') {
          this.saveCollection('Voucher', false, true);
        } else if (this.serviceType === 'DELIVERY') {

        }
      } else {
        // check for min order amount for online payment
        if (type !== 'Reserved') {
          if (paidbyolars) {
            continuePayment = true;
          } else {
            if (paymentAmount < 1) {
              continuePayment = false;
              this.alerts = [];
              this.alerts.push({
                type: 'warning',
                msg: 'Payment should be min of 1 ' + this.settings.company_currency,
                timeout: 5000,
                isOpen: true
              });
              this.clickCount = 0;
            } else {
              continuePayment = true;
            }
          }
        } else {
          continuePayment = true;
        }
        if (continuePayment) {
          if (this.serviceType === 'DINE_IN') {
            this.saveDineIn(this.paymentTypeSelected, paidbyolars);
          } else if (this.serviceType === 'COLLECTION') {
            this.saveCollection(this.paymentTypeSelected, paidbyolars);
          } else if (this.serviceType === 'DELIVERY') {

          }
        }
      }
    }
    catch (ex) {
      this.clickCount = 0;
    }
  }


  onProceedPaymentClick() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
    if (this.serviceType === 'DINE_IN') {
      this.saveDineIn(this.paymentTypeSelected);
    } else if (this.serviceType === 'COLLECTION') {
      this.saveCollection(this.paymentTypeSelected);
    } else if (this.serviceType === 'DELIVERY') {

    }
  }

  // Method to save the dine in details to db
  saveDineIn(paymentType, paidbyOlars = false, paidbyvouchers = false) {
    try {
      let serviceActiveId = this.webstorage.sessionSt_service_active_id;
      if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
        serviceActiveId = 1;
      }
      //let userStoreIndex = -1;
      const selectedStore = this.settingService.getSelectedStore(this.serviceType);
      if (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true) {
        selectedStore.serviceQRScanned = false;
      }
      this.userSelectedStore = selectedStore;
      let dineData: any = '';
      dineData = this.getDineData(selectedStore, selectedStore.storeCart, paymentType, paidbyOlars, paidbyvouchers);
      //dineData.oodcdr_mobile = this.ecomservice.encryptWithKey(dineData.oodcdr_mobile);
      // dineData.oodcdr_name = this.ecomservice.encryptWithKey(dineData.oodcdr_name);
      if (dineData.oodcdr_address) {
        dineData.oodcdr_address = dineData.oodcdr_address.trim();
      }
      dineData.oodcdr_address = dineData.oodcdr_address;
      let userAddress = {
        ooca_ooc_guid: this.webstorage.localSt_user_id,
        ooca_address_label: 'Delivery address',
        ooca_address: this.cookie.cookie_checkout_address,
        ooca_city: this.cookie.cookie_checkout_city,
        ooca_postal_code: this.cookie.cookie_checkout_pincode,
        ooca_latlang: this.cookie.cookie_latlng_delivery_address_change,
        ooca_address_url: "http://maps.google.co.uk/maps?q=" + (this.cookie.cookie_latlng_delivery_address_change),
        ooca_address_landmark: this.cookie.cookie_checkout_landmark,
        ooca_place_id: this.cookie.cookie_address_change_place_id
      }
      //const encryptedData = this.DineInEncryptedData(dineData);
      //save pax details locally
      let paxDetails = [];
      this.checkoutform.value.paxdetailsList.forEach(pax => {
        let objPax = {
          paxName: pax.pax_name,
          paxCountryCode: pax.pax_country_code,
          paxPhone: pax.pax_contact,
          paxVaccinatedDate: pax.pax_vaccinated_date,
          paxVerified: true,
          paxDependent: pax.pax_dependent,
        }
        paxDetails.push(objPax);
      });
      selectedStore.servicepax = this.checkoutform.value.pax;
      selectedStore.serviceLocationAreaId = dineData.oodcdr_ooa_guid;
      selectedStore.serviceLocationAreaName = dineData.oodcdr_area_name;
      selectedStore.serviceListPaxDetails = paxDetails;
      //this.webstorage.localSt_user_service_request = this.userServiceBase;
      this.settingService.setUserSerivce(this.userServiceBase)
      //return;
      this.Payment(paymentType, dineData, dineData.Payments, userAddress);
    }
    catch (ex) {
      this.clickCount = 0;
    }
    //this.AmBankTestPayment();
  }

  getDineData(storeBase: StoreServiceBase, cartBase: StoreCartBase, paymentType, paidbyOlars = false, paidbyVoucher = false): any {

    const salesorder = {
      sales_order_status: 'DRAFT',
      order_surcharge_total: this.userSelectedStore.storeCart.orderServiceCharge.toFixed(2),
      order_gross_total: this.userSelectedStore.storeCart.orderSubTotal.toFixed(2),
      order_tax_total: this.userSelectedStore.storeCart.orderTax.toFixed(2),
      order_discount_total: '',
      order_net_total_amount: this.userSelectedStore.storeCart.orderTotal.toFixed(2),
      sales_order_location_guid: this.userSelectedStore.serviceLocationGuid,
      sales_order_id: this.getOrderID(),
      sales_order_remarks: '',
      sales_order_notes: '',
      sales_order_company_sell_prices: this.settings.company_sell_price_tax + '',
      mm_sales_order_items: [],
      mm_sales_order_surcharges: [],
      sales_order_delivery_tax_guid: null,
      sales_order_delivery_tax_rate: null,
      sales_order_delivery_tax_amount: 0
    };

    this.userSelectedStore.storeCart.orderItems.forEach(item => {
      // item
      const saleOrderItem = {
        soi_item_guid: item.itemGuid,
        soi_item_name: item.itemName,
        mm_sales_order_items_standard_composite_variant_service_details: [],
        mm_sales_order_modifier_mapping: [],
        item_has_variant: '',
        discounts: [],
        remarks: [""],
        iuic_pkid: item.iuic_pkid > 0 ? item.iuic_pkid : null,
        quantity: item.quantity,
        reward: null
      };
      // variants
      item.variantList.forEach(variant => {
        if (variant.selected) {
          const saleorderitemvariant = {
            soiscvsd_soi_guid: item.itemGuid,
            soiscvsd_isvsd_guid: variant.variantGuid,
            soiscvsd_name: variant.variantName ? variant.variantName : '',
            soiscvsd_sku: variant.variantSKU ? variant.variantSKU : '',
            price: variant.variantDineInPriceDiscounted ? variant.variantDineInPriceDiscounted.toFixed(2) : variant.variantDineInPrice.toFixed(2),
            soiscvsd_tax_guid: variant.variantTaxGuid,
            tax_rate: variant.variantTaxRate.toFixed(2),
            tax_amount: variant.variantDineInTaxAmt.toFixed(4),
            quantity: variant.variantQty.toString(),
            soiscvsd_status: 'ORDERED',
            soiscvsd_notes: item.specialRequest ? item.specialRequest : '',
            discount_total_item_amount: '',
            total_amount: '',
          };
          saleOrderItem.mm_sales_order_items_standard_composite_variant_service_details.push(saleorderitemvariant);
        }
      });
      saleOrderItem.item_has_variant = saleOrderItem.mm_sales_order_items_standard_composite_variant_service_details.length > 0 ? 'true' : 'false';
      // modifier set
      item.modifierSetList.forEach(set => {
        if (set.modifierSetSelected) {
          const modifierset = {
            somm_soi_guid: item.itemGuid,
            somm_imm_guid: set.modifiermappingGuid,
            somm_modifier_name: set.modifierName,
            mm_sales_order_modifier_mapping_options: [],
            modifier_items: []
          };
          set.modifierOptions.forEach(option => {
            if (option.optionSelected) {
              const modifieroption = {
                sommo_somm_guid: null,
                sommo_immo_guid: option.optionGuid,
                sommo_option_name: option.optionName,
                option_pkid: option.option_pkid,
                sommo_tax_guid: option.optionTaxGuid,
                tax_rate: option.optionTaxRate.toFixed(2),
                tax_amount: option.optionTaxAmt.toFixed(4),
                price: option.optionPrice.toFixed(2),
                quantity: option.optionQuantity.toFixed(2),
                discount_total_item_amount: '',
                total_amount: ''
              };
              modifierset.mm_sales_order_modifier_mapping_options.push(modifieroption);
            }
            if (option.optionSelected) {
              const modifierItem = {
                item_pkid: option.imm_item_pkid,
                modifier_option_pkid: option.option_pkid,
                modifier_option_variant_pkid: 146,
                modifier_set_pkid: -1,
                selected_modifier_options: option.modifiers_into_modifier.filter(x => x.optionSelected).map(o => ({
                  option_pkid: o.option_pkid,
                  repeat_count: 1
                }))
              }
              modifierset.modifier_items.push(modifierItem);
            }
          });
          saleOrderItem.mm_sales_order_modifier_mapping.push(modifierset);
        }
      });

      if (item.discounted && !item.isBuyItem) {

        let amount = item.quantity * item.discountAmount;
        if (item.modifierSetList.length > 0) {
          // amount = item.totalPrice - amount;
        }
        let disc_percentage = 0;
        const allDiscounts = this.settingService.getDiscounts();
        const selectedDiscount = allDiscounts.find(x => x.discount_pkid === item.selectedDiscountId);

        const discounts = [{
          disc_percentage: selectedDiscount ? selectedDiscount.discount_value : 0,
          disc_amount: amount,
          disc_pkid: item.selectedDiscountId,
          disc_source: "AUTO",
          disc_type: selectedDiscount ? selectedDiscount.discount_value_type : '',
        }];

        saleOrderItem.discounts = discounts;
      }

      if (item.hasReward) {
        let amount = item.quantity * item.discountAmount;
        saleOrderItem.reward = {
          pkid: item.reward.reward_pkid,
          name: item.reward.name,
          benefitCountPkid: item.reward.benefit_count_pkid,
          valueType: item.reward.value_type,
          value: item.reward.reward_value,
          amount: amount,
          benefitCountRemaining: 0,
          benefitCountSocbcCount: 0,
          pointToRedeem: item.reward.point,
          maxAmount: item.reward.max_value,
          maxTimePerOrder: 1,
          customerRewardPkid: item.reward.customer_reward_pkid
        };
      }

      if (item.specialRequest) saleOrderItem.remarks = [item.specialRequest];

      salesorder.mm_sales_order_items.push(saleOrderItem);
    });
    const emailBase = new EmailBase();
    emailBase.emailSubject = 'Dinein Service Confirmed';
    emailBase.emailBody = 'Hi ' + this.userSelectedStore.serviceLocationName + ' <br />You have new dine in service confirmed!!<br /> Thanks.';
    emailBase.emailToMailList = [];
    // emailBase.emailToMailList.push(this.settings.oosrcs_reservation_email);
    if (this.settings.oosrcs_reservation_email) {
      let emailList = this.settings.oosrcs_reservation_email.split(',');
      for (let i = 0; i < emailList.length; i++) {
        emailBase.emailToMailList.push(emailList[i]);
      }
    }

    let netTotalAmount = cartBase.orderTotal.toFixed(2);
    let cashbacktotal = (cartBase.orderPickupCashback + cartBase.voucherAmount + cartBase.orderCashbackOlar).toFixed(2);
    this.PaymentAmount = cartBase.orderTotal - this.loyaltyAmount;
    // sales order discount total
    salesorder.order_discount_total = cartBase.orderDiscountReferral.toFixed(2);
    salesorder.order_net_total_amount = netTotalAmount;
    let paymentIdDetails = this.getPaymentIdByType();

    let dineData = {
      oodcdr_guid: this.userSelectedStore.serviceGuid,
      oodcdr_type: this.userSelectedStore.serviceType,
      order_date_time: this.userSelectedStore.serviceDatetime,
      oodcdr_oot_pkid: storeBase.serviceLocationTableId,
      oodcdr_oot_table_name: storeBase.serviceLocationTableName,
      oodcdr_location_pkid: this.userSelectedStore.locationPkid,
      oodcdr_name: this.userInfo.firstName,
      oodcdr_mobile: this.userInfo.phoneNumber,
      customer_pkid: this.userInfo.userPkid,
      oodcdr_country_dial_code: this.userInfo.dialCode,
      oodcdr_address: this.userServiceBase.userAddress ? this.userServiceBase.userAddress : '',
      oodcdr_postal_code: this.userServiceBase.userPostalCode ? this.userServiceBase.userPostalCode : '',
      oodcdr_city: this.userServiceBase.userCity ? this.userServiceBase.userCity : '',
      oodcdr_email: this.userServiceBase.userEmail ? this.userServiceBase.userEmail : '',
      oodcdr_special_requests: this.userSelectedStore.serviceRemarks ? this.userSelectedStore.serviceRemarks : '',
      oodcdr_company_guid: this.settings.oosrcs_company_guid,
      oodcdr_status: 'OPEN',
      oodcdr_olar_client_id: this.webstorage.localSt_client_id,
      companyId: this.userSelectedStore.serviceCompanyId,
      oodcdr_is_qrcodescan: this.QRCodeType,
      string_net_total_amount: netTotalAmount,
      oodcdr_oadp_amount: cartBase.orderDiscountTotalOADP,
      oodcdr_menu_discount_amount: cartBase.orderDiscountTotal,
      string_cashback_total_amount: cashbacktotal,
      EmailBase: {
        ToMailList: emailBase.emailToMailList,
        Subject: emailBase.emailSubject,
        Body: emailBase.emailBody
      },
      Payments: {
        amount: this.PaymentAmount.toFixed(2),
        oodcdrp_status: 'STARTED',
        oodcdrp_bank_code: paymentIdDetails['bankCode'],
        oodcdrp_currency: 'MYR',
        oodcdrp_transaction_description: this.serviceType,
        oodcdrp_ipaddress: this.webstorage.localSt_ip ? this.webstorage.localSt_ip : '127.0.0.1',
        key_index: '1',
        payment_id: paymentIdDetails['paymentId'].toString()
      },
      sales_orders: salesorder,
      Key: this.webstorage.localSt_olar_key,
      olarme_cashback_discount: null,
      Voucher: null,
      Referrals: null,
      list_olarme_cashback_discount: null,
      order_olar_points_redeemed: 0,
      order_olar_points_amount: '',
      user_distance: Number(Number(this.distance).toFixed(2)),
      list_pax_details: [],
      oodcdr_pax: this.userInfo.pax,
      oodcdr_ooa_guid: null,
      oodcdr_area_name: ''
    };

    //pax details
    let paxnumber = this.userInfo.pax;
    dineData.oodcdr_pax = paxnumber;

    return dineData;
  }


  yearIndex() {
    // 2024 = 0
    const currentYear = new Date().getFullYear();
    return currentYear - 2024;
  }

  isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }

  dayOfYear(date) {
    const monthDays = [31, this.isLeapYear(date.getFullYear()) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    let dayCount = 0;

    for (let i = 0; i < date.getMonth(); i++) {
      dayCount += monthDays[i];
    }

    dayCount += date.getDate();
    return dayCount;
  }

  formatDayOfYear(day) {
    return String(day).padStart(3, '0');
  }

  getCurrentSeconds() {
    const now = new Date();
    const seconds = now.getSeconds();
    return String(seconds).padStart(2, '0');
  }


  // Method to make the dinein payment
  Payment(paymentType, dineInEncrypted, paymentDetails, userAddress) {
    //console.log("Pay");
    this.retrycount = this.retrycount + 1;
    const model = this.getOrderData(dineInEncrypted);

    this.ecomservice.httpPost(EcomNetworkUtils.POST_ADD_SERVICE, model, '', true, true).subscribe(response => {

      //console.log(response);
      if (response['status'] === 403) {
        this.clickCount = 0;
        this.router.navigate(['unauthorized']);
      } else {

        this.webstorage.sessionSt_user_order_reference = null;
        if (response.status === 200) {

          const userService = this.settingService.getUserSerivce();
          userService.entireReward = undefined;
          userService.order_level_reward = undefined;
          userService.spentsPoints = 0;
          userService.gainedPoints = 0;
          this.settingService.setUserSerivce(userService);

          const selectedStore = this.settingService.getSelectedStore(this.serviceType);
          selectedStore.serviceGuid = response.value;
          const self = this;
          this.webstorage.localSt_user_service_request = this.userServiceBase;
          this.webstorage.sessionSt_frompage = 'checkout';
          const order = new OrderDetails();


          if (paymentType !== 'Reserved' && paymentType !== 'Olars' && paymentType !== 'Voucher' && paymentType !== 'Loyalty') {
            const referencenumber = response.listValue;
            const order_reference = {
              Key: this.ecomservice.GetOlarConfigValue('rhPayments_merchant_key_key_index1'),
              MerchantId: this.ecomservice.GetOlarConfigValue('rhPayments_merchant_id'),
              ReferenceNumber: response['listValue'],
              Amount: this.PaymentAmount.toFixed(2),
              Currency: paymentDetails.oodcdrp_currency
            };
            const companySetting = this.settingService.getCompanySetting();
            const locationSetting = this.settingService.getLocationSetting();
            const user_service = this.settingService.getUserSerivce();
            const user_info = this.settingService.getUserInfo();

            const localData = {
              type: paymentType,
              order_reference: order_reference,
              company_setting: companySetting,
              location_setting: locationSetting,
              user_service: user_service,
              user_info: user_info
            };

            if (paymentType === "DuitNow") {
              this.getQRPayment(referencenumber, localData);
            } else {

              this.webstorage.sessionSt_user_order_reference = localData;
              order.PaymentType = paymentType;
              order.Reference_Number = referencenumber;
              order.Amount = this.PaymentAmount.toFixed(2);
              order.Currency = paymentDetails.oodcdrp_currency;
              order.Transaction_Description = paymentDetails.oodcdrp_transaction_description;
              order.Customer_Name = selectedStore.serviceUsername;
              order.Customer_Email = selectedStore.serviceUserEmail;
              order.Customer_Contact = selectedStore.serviceUserMobilenumber;
              order.Customer_IP = this.webstorage.localSt_ip;
              this.saveUserAddress(userAddress, false);
              this.sendPaymentRequest(order, model);
              //this.testPaymentLocal(this.PaymentAmount.toFixed(2), response.listValue);
            }


          } else {
            // let userStoreIndex = -1;
            // const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
            //   userStoreIndex = index;
            //   return obj.serviceLocationGuid === this.locationSelected.oocls_location_pkid && obj.serviceType === this.serviceType && !obj.serviceCompleted;
            // });

            this.saveUserAddress(userAddress, false);
            // cash on delevery or pay at counter or paid by olars
            this.router.navigate(['status-dinein'], { queryParams: { companyId: this.userSelectedStore.serviceCompanyId, serviceId: response.value } });
          }
        } else {
          if (this.retrycount < 3) {
            this.saveDineIn(paymentType);
          } else {
            this.clickCount = 0;
            this.alerts = [];
            this.alerts.push({
              type: 'warning',
              msg: 'currently not able to proceed try after sometimes!',
              timeout: 5000,
              isOpen: true
            });
            this.commonLoading.show = false;
          }
        }
      }
    });
  }

  getOrderData(dataEncrypted: any) {
    //console.log('DineInPayment');

    const dayOfTheYear = this.dayOfYear(new Date());
    const formattedDayOfTheYear = this.formatDayOfYear(dayOfTheYear);
    //console.log(`Hôm nay là ngày thứ ${formattedDayOfTheYear} trong năm.`);
    //console.log(`ORDER ID: ${this.yearIndex()}${formattedDayOfTheYear}`);

    const data = { ...dataEncrypted, orderNumber: `${this.yearIndex()}${formattedDayOfTheYear}${this.getCurrentSeconds()}` }
    //console.log(data);

    const items = dataEncrypted.sales_orders.mm_sales_order_items.map(x => {
      let modifier_options = [];
      let modifier_items = [];
      if (x.mm_sales_order_modifier_mapping.length) {
        const options = x.mm_sales_order_modifier_mapping
          .map(o => o.mm_sales_order_modifier_mapping_options);

        const arrayOptions = [].concat(...options);

        modifier_options = arrayOptions.map(option => ({
          option_pkid: option.option_pkid,
          repeat_count: 1
        }));

        const modifierItems = x.mm_sales_order_modifier_mapping
          .map(o => o.modifier_items);
        modifier_items = [].concat(...modifierItems);
      }

      let quantity = 1;

      if (x.mm_sales_order_items_standard_composite_variant_service_details.length) {
        quantity = x.mm_sales_order_items_standard_composite_variant_service_details[0].quantity;
      }

      const item = {
        is_deleted: !!x.soi_is_deleted,
        is_item_synced: true,
        item_discounts: x.discounts,
        item_reward: x.reward,
        item_pkid: x.soi_item_guid,
        iuic_pkid: x.iuic_pkid,
        item_quantity: x.quantity,
        //item_uuid : null,
        modifier_items: modifier_items,
        order_id: x.orderNumber,
        //reg_pkid: 36,
        remarks: x.remarks,
        selected_modifier_options: modifier_options,
        selected_variant_pkid: x.mm_sales_order_items_standard_composite_variant_service_details.length ? x.mm_sales_order_items_standard_composite_variant_service_details[0].soiscvsd_isvsd_guid : 0,
        //suborder_id: "SOp-10630052024021943"
      }

      return item;
    }
    );

    const setting = this.settingService.getLocationSetting();

    const companyId = setting.company_id;
    const companyPkid = setting.oosrcs_company_pkid;
    let status = setting.oomls_order_acceptance_unpaid === "A" ? "OPEN" : "DRAFT";

    const paymentId = +dataEncrypted.Payments.payment_id;

    // != 1 => Paid
    if (paymentId !== 1) {
      status = setting.oomls_order_acceptance_paid === "A" ? "PAID" : "DR_PAID";
    }
    let customer_loyalty_pointbase = this.userServiceBase.customer_loyalty_pointbase as any;

    let spentWithPoints = this.userServiceBase.spentsPoints;
    let online_payments = [];
    if (this.loyaltyAmount > 0) {
      online_payments = [
        {
          paid_amount: this.loyaltyAmount,
          payment_id: 0,
          transaction_id: null,
          payment_type: "",
          online_payment_name: "Loyalty"
        }
      ];
      spentWithPoints += this.loyaltyAmount * this.userInfo.ratio;
      if (customer_loyalty_pointbase) {
        const amount = Number((customer_loyalty_pointbase.soclp_sales_order_amount - this.loyaltyAmount).toFixed(2));
        customer_loyalty_pointbase.soclp_sales_order_amount = amount;
        customer_loyalty_pointbase.soclp_spent_with_points = spentWithPoints;

      } else {
        const amount = Number((this.userSelectedStore.storeCart.orderTotal).toFixed(2));

        customer_loyalty_pointbase = {
          soclp_customer_pkid: this.userInfo.userPkid,
          soclp_sales_order_amount: amount,
          soclp_gained_points: this.userServiceBase.gainedPoints,
          soclp_spent_points: 0,
          soclp_spent_with_points: spentWithPoints,
          customer_benefit_counts: []
        }
      }
    }

    let sos_reward_pkid_redeemed = [];
    let sos_benefit_count_redeemed = [];
    let usedPoints = 0;
    if (this.userServiceBase.loyalties) {
      sos_reward_pkid_redeemed = this.userServiceBase.loyalties.filter(x => x.loyalty_customer_reward_pkid > 0).map(x => x.loyalty_customer_reward_pkid);
      sos_benefit_count_redeemed = this.userServiceBase.loyalties.filter(x => x.loyalty_benefit_count_pkid > 0).map(x => x.loyalty_benefit_count_pkid);
      usedPoints = this.userServiceBase.loyalties.reduce((total, t) => total + t.loyalty_spent_points, 0);
    }
    if (this.userServiceBase.order_level_reward) {
      const reward = this.userServiceBase.order_level_reward as any;
      sos_reward_pkid_redeemed.push(reward.pkid);

    }
    const newFormart = {
      order_pkid: this.webstorage.sessionSt_status_serviceid,
      company_id: companyId,
      company_pkid: companyPkid,
      items: items,
      loc_pkid: dataEncrypted.oodcdr_location_pkid,
      order_assigned_pkid: 0,//????
      order_client_status: status,
      order_datetime: new Date(),
      order_dinein_table_name: dataEncrypted.oodcdr_oot_table_name,
      order_dinein_table_pkid: dataEncrypted.oodcdr_oot_pkid,
      order_dinein_table_pax: this.userInfo.pax,
      //order_id: "015148SOp-111",
      order_is_placed: true,
      order_json_pkid: 0,
      order_net_total: dataEncrypted.string_net_total_amount,
      order_number: `${this.yearIndex()}${formattedDayOfTheYear}${this.getCurrentSeconds()}`,
      //order_payment_data: "[]",
      order_service_type: dataEncrypted.oodcdr_type,
      order_status: status,
      order_username: "",
      reg_pkid: setting.store_register_primary_nominated_pkid,
      surcharges: this.userServiceBase.surcharges,
      order_level_discount: this.userServiceBase.order_level_discount,
      order_level_reward: this.userServiceBase.order_level_reward,
      loyalties: this.userServiceBase.loyalties,
      customer_loyalty_pointbase: customer_loyalty_pointbase,
      sales_order_loyalty_points_earned: this.userServiceBase.gainedPoints,
      sales_order_loyalty_points_redeemed: spentWithPoints + usedPoints
    }
    //console.log("newFormart", newFormart);
    const selectedStore = this.settingService.getSelectedStore(this.serviceType);

    // const itemsGainpoints = this.userSelectedStore.storeCart.orderItems.filter(x => x.earning_points);

    // if (itemsGainpoints) {
    //   debugger
    // }
    const userService = this.settingService.getUserSerivce();
    const merchantKey = this.ecomservice.GetOlarConfigValue('rhPayments_merchant_key_key_index1');
    const merchantId = this.ecomservice.GetOlarConfigValue('rhPayments_merchant_id'); //olarconfig.rhPayments.merchant_id;

    return {
      salesOrder: newFormart,
      onlineOrder: dataEncrypted,
      isTableQRCode: this.QRCodeType,
      transactionReference: selectedStore.serviceGuid,
      gainedPoints: userService.gainedPoints,
      spentsPoints: spentWithPoints + usedPoints,
      rewardPkidRedeemed: sos_reward_pkid_redeemed.join(", "),
      benefitCountRedeemed: sos_benefit_count_redeemed.join(", "),
      onlinePayments: online_payments,
      merchantId,
      merchantKey
    }
  }

  // Method to handle the collection data save to db
  saveCollection(paymentType, paidbyOlars = false, paidbyvouchers = false) {
    let serviceActiveId = this.webstorage.sessionSt_service_active_id;
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
      serviceActiveId = 1;
    }
    let userStoreIndex = -1;
    const selectedStore = this.settingService.getSelectedStore(this.serviceType);
    if (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true) {
      selectedStore.serviceQRScanned = false;
    }
    this.userSelectedStore = selectedStore;

    const collectionData = this.getDineData(selectedStore, selectedStore.storeCart, paymentType, paidbyOlars, paidbyvouchers);
    if (collectionData.oodcdr_address) {
      collectionData.oodcdr_address = collectionData.oodcdr_address.trim();
    }

    let userAddress = {
      ooca_ooc_guid: this.webstorage.localSt_user_id,
      ooca_address_label: 'Delivery address',
      ooca_address: this.cookie.cookie_checkout_address,
      ooca_city: this.cookie.cookie_checkout_city,
      ooca_postal_code: this.cookie.cookie_checkout_pincode,
      ooca_latlang: this.cookie.cookie_latlng_delivery_address_change,
      ooca_address_url: "http://maps.google.co.uk/maps?q=" + (this.cookie.cookie_latlng_delivery_address_change),
      ooca_address_landmark: this.cookie.cookie_checkout_landmark,
      ooca_place_id: this.cookie.cookie_address_change_place_id
    }
    this.Payment(paymentType, collectionData, collectionData.Payments, userAddress);
  }

  saveUserAddress(input, displayLoading) {
    return
    this.ecomservice.httpPost(EcomNetworkUtils.POST_SAVE_USER_ADDRESS, input, '', true, displayLoading).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {

        }
      }
    });
  }

  // Method to get the payment id by payment type
  getPaymentId(selectedPaymentType) {
    let paymentType = 1;
    switch (selectedPaymentType) {
      case 'Reserved':
        this.PaymentTypeSelectedName = 'Pay at counter';
        paymentType = PaymentId.Reserved;
        break;
      case 'Visa_MasterCard':
        this.PaymentTypeSelectedName = 'Visa Master Card';
        paymentType = PaymentId.Visa_MasterCard;
        break;
      case 'FPX_PERSONAL_ACCOUNT':
        this.PaymentTypeSelectedName = 'FPX Personal Account';
        paymentType = PaymentId.FPX_PERSONAL_ACCOUNT;
        break;
      case 'AMEX_CreditCard':
        this.PaymentTypeSelectedName = 'Amex Credit Card';
        paymentType = PaymentId.AMEX_CreditCard;
        break;
      case 'Alipay_Spot_QR':
        this.PaymentTypeSelectedName = 'Alipay QR';
        paymentType = PaymentId.Alipay_Spot_QR;
        break;
      case 'UPOP':
        this.PaymentTypeSelectedName = 'Union Pay';
        paymentType = PaymentId.UPOP;
        break;
      case 'UPI_QR_Code':
        this.PaymentTypeSelectedName = 'Union Pay QR';
        paymentType = PaymentId.UPI_QR_Code;
        break;
      case 'Internet_Banking':
        this.PaymentTypeSelectedName = 'Internet Banking';
        paymentType = PaymentId.Internet_Banking;
        break;
      case 'FPX_CORPORATE_ACCOUNT':
        this.PaymentTypeSelectedName = 'FPX Corporate Account';
        paymentType = PaymentId.FPX_CORPORATE_ACCOUNT;
        break;
      case 'MerchanTrade':
        this.PaymentTypeSelectedName = 'Merchant Trade';
        paymentType = PaymentId.MerchanTrade;
        break;
      case 'Axiata_Boost':
        this.PaymentTypeSelectedName = 'Boost';
        paymentType = PaymentId.Axiata_Boost;
        break;
      case 'Maybank_QR':
        this.PaymentTypeSelectedName = 'Maybank QR';
        paymentType = PaymentId.Maybank_QR;
        break;
      case 'DiGi_VCash':
        this.PaymentTypeSelectedName = 'DIGI VCash';
        paymentType = PaymentId.DiGi_VCash;
        break;
      case 'WeChat_Pay':
        this.PaymentTypeSelectedName = 'WeChat Pay';
        paymentType = PaymentId.WeChat_Pay;
        break;
      case 'Alipay_Online':
        this.PaymentTypeSelectedName = 'Alipay Online 111';
        paymentType = PaymentId.Alipay_Online;
        break;
      case 'AirAsia_BIG':
        this.PaymentTypeSelectedName = 'AirAsia Big';
        paymentType = PaymentId.AirAsia_BIG;
        break;
      case 'Grab_Pay':
        this.PaymentTypeSelectedName = 'Grab Pay';
        paymentType = PaymentId.Grab_Pay;
        break;
      case 'Internet_Banking_MayBank':
        this.PaymentTypeSelectedName = 'Internet Banking Maybank';
        paymentType = PaymentId.Internet_Banking_MayBank;
        break;
      case 'Internet_Banking_CIMB':
        this.PaymentTypeSelectedName = 'Internet Banking CIMB';
        paymentType = PaymentId.Internet_Banking_CIMB;
        break;
      case 'Internet_Banking_RHB':
        this.PaymentTypeSelectedName = 'Internet Banking RHB';
        paymentType = PaymentId.Internet_Banking_RHB;
        break;
      case 'Internet_Banking_Public_Bank':
        this.PaymentTypeSelectedName = 'Internet Banking Public Bank';
        paymentType = PaymentId.Internet_Banking_Public_Bank;
        break;
      case 'Internet_Banking_Hong_Leong_Bank':
        this.PaymentTypeSelectedName = 'Internet Banking Hong Leong Bank';
        paymentType = PaymentId.Internet_Banking_Hong_Leong_Bank;
        break;
      case 'Internet_Banking_AmBank':
        this.PaymentTypeSelectedName = 'Internet Banking AmBank';
        paymentType = PaymentId.Internet_Banking_AmBank;
        break;
      case 'Internet_Banking_Bank_Rakyat':
        this.PaymentTypeSelectedName = 'Internet Banking Bank Rakyat';
        paymentType = PaymentId.Internet_Banking_Bank_Rakyat;
        break;
      case 'Internet_Banking_Bank_Muamalat':
        this.PaymentTypeSelectedName = 'Internet Banking Bank Muamalat';
        paymentType = PaymentId.Internet_Banking_Bank_Muamalat;
        break;
      case 'Internet_Banking_BSN':
        this.PaymentTypeSelectedName = 'Internet Banking BSN';
        paymentType = PaymentId.Internet_Banking_BSN;
        break;
      case 'Hong_Leong_Bank_Scan_and_Pay':
        this.PaymentTypeSelectedName = 'Hong Leong Bank Scan & Pay';
        paymentType = PaymentId.Hong_Leong_Bank_Scan_and_Pay;
        break;
      case 'Touch_n_Go':
        this.PaymentTypeSelectedName = 'Touch n go';
        paymentType = PaymentId.Touch_n_Go;
        break;
      case 'Diners_Club':
        this.PaymentTypeSelectedName = 'Dinners Club';
        paymentType = PaymentId.Diners_Club;
        break;
      case 'Loyalty':
        this.PaymentTypeSelectedName = 'Loyalty';
        paymentType = PaymentId.Loyalty;
        break;
      case 'DuitNow':
        this.PaymentTypeSelectedName = 'DuitNow';
        paymentType = PaymentId.DuitNow_QR;
        break;
    }
    return paymentType;
  }

  getPaymentIdByType(): any {
    let paymentid = 0;
    let bankcode = '';
    let selectedpaymenttype = this.paymentTypes.find(obj => {
      return obj.option_selected === true;
    });
    if (!selectedpaymenttype) return;

    if (selectedpaymenttype.type === 'card') {
      paymentid = this.getPaymentId('Visa_MasterCard');
    } else if (selectedpaymenttype.type === 'payatcounter') {
      paymentid = this.getPaymentId('Reserved');
    } else if (selectedpaymenttype.type === 'loyalty') {
      paymentid = this.getPaymentId('Loyalty');
    } else if (selectedpaymenttype.type === 'DuitNow') {
      paymentid = this.getPaymentId('DuitNow');
    }
    else if (selectedpaymenttype.type === 'fpx') {
      paymentid = this.getPaymentId('FPX_PERSONAL_ACCOUNT');
      if (this.environment === 'Production') {
        let fpxselected = selectedpaymenttype.production_list.find(obj => {
          return obj.selected === true;
        });
        bankcode = fpxselected.value;
      } else {
        let fpxselected = selectedpaymenttype.staging_list.find(obj => {
          return obj.selected === true;
        });
        bankcode = fpxselected.value;
      }
    } else if (selectedpaymenttype.type === 'ewallets') {
      if (this.environment === 'Production') {
        let walletselected = selectedpaymenttype.production_list.find(obj => {
          return obj.selected === true;
        });
        paymentid = this.getPaymentId(walletselected.value);
      } else {
        let walletselected = selectedpaymenttype.staging_list.find(obj => {
          return obj.selected === true;
        });
        paymentid = this.getPaymentId(walletselected.value);
      }
    }
    return {
      paymentId: paymentid,
      bankCode: bankcode
    };
  }

  // Method to send the payment request to bank server
  sendPaymentRequest(request: OrderDetails, model = null) {
    if (this.customerDetailsModalRef) {
      this.customerDetailsModalRef.hide();
    }
    //let userStoreIndex = -1;
    const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {

      return obj.serviceLocationGuid === this.locationSelected.oocls_location_pkid && obj.serviceType === this.serviceType && !obj.serviceCompleted;
    });


    if (this.checkoutform.value.mobile) {
      this.cookie.cookie_user_phone = this.checkoutform.value.mobile.replace('-', '').replace(' ', '');
      this.cookie.cookie_user_country_code = this.checkoutform.value.countryCode;
    }

    //signature for request as per doc
    // Signature Value = "Merchant Key" + "Revpay Merchant ID" + "Reference Number" + "Amount" + "Currency" 
    const merchantKey = this.ecomservice.GetOlarConfigValue('rhPayments_merchant_key_key_index1');
    const merchantId = this.ecomservice.GetOlarConfigValue('rhPayments_merchant_id'); //olarconfig.rhPayments.merchant_id;
    const referenceNumber = request.Reference_Number;
    const signatureValue = merchantKey + merchantId + referenceNumber + request.Amount + request.Currency;
    const signature = this.ecomservice.generateSHA512Hash(signatureValue);

    let paymentIdDetails = this.getPaymentIdByType();
    const input = {
      Revpay_Merchant_ID: merchantId,
      Payment_ID: paymentIdDetails['paymentId'],
      Bank_Code: paymentIdDetails['bankCode'],
      Reference_Number: request.Reference_Number,
      Amount: request.Amount,
      Currency: request.Currency,
      Transaction_Description: request.Transaction_Description,
      Customer_Name: request.Customer_Name,
      Customer_Email: request.Customer_Email,
      Customer_Contact: request.Customer_Contact,
      Customer_IP: request.Customer_IP,
      Installment_Plan: '',
      Installment_Term: '',
      Key_Index: 1,
      Signature: signature,
      Return_URL: this.ecomservice.GetOlarConfigValue('rhPayments_paymentfrontreturnurl'),
      Promo_Code: request.Promo_Code,
      Backend_URL: this.ecomservice.GetOlarConfigValue('rhPayments_paymentbackendurl')
    };
    this.rhPaymentForm.controls['Revpay_Merchant_ID'].setValue(input.Revpay_Merchant_ID);
    this.rhPaymentForm.controls['Payment_ID'].setValue(input.Payment_ID);
    if (input.Payment_ID == 3) {
      this.rhPaymentForm.controls['Bank_Code'].setValue(input.Bank_Code);
      let number = '';
      let countryCode = '';
      number = this.customerDetailsForm.getRawValue().contact.nationalNumber;
      //countryCode = this.customerDetailsForm.getRawValue().contact.countryCode;
      number = number.replace('-', '').replace(' ', '');

      input.Customer_Name = this.customerDetailsForm.getRawValue().name;
      input.Customer_Email = this.customerDetailsForm.getRawValue().email;
      input.Customer_Contact = number;
    }

    this.rhPaymentForm.patchValue({
      Reference_Number: input.Reference_Number,
      Amount: input.Amount,
      Currency: input.Currency,
      Transaction_Description: input.Transaction_Description,
      Customer_Name: input.Customer_Name,
      Customer_Email: input.Customer_Email,
      Customer_Contact: input.Customer_Contact,
      Customer_IP: input.Customer_IP,
      Installment_Plan: input.Installment_Plan,
      Installment_Term: input.Installment_Term,
      Key_Index: input.Key_Index,
      Signature: input.Signature,
      Return_URL: input.Return_URL,
      Backend_URL: input.Backend_URL
    });
    if (input.Promo_Code) {
      this.rhPaymentForm.controls['Promo_Code'].setValue(input.Promo_Code);
    }
    // don't display payment change option to user
    if (input.Payment_ID == 2) {
      let displayMethods = JSON.stringify({ Displaying_Payment_Method: ['2'] });
      this.rhPaymentForm.controls['Customization'].setValue(displayMethods);
    }
    const requestUrl = this.ecomservice.GetOlarConfigValue('rhPayments_paymentrequesturl');
    document.forms[1].action = requestUrl;
    document.forms[1].submit();
  }



  closePromo() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
  }

  onApplyPromoCodeClick(promo: any) {

  }

  onOlarsClick() {

  }


  onCloseOlarmePromotionClick() {
    this.modalRefOlarmePromotion.hide();
  }

  //input validation to enter only number
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  // Close Olar Pop-up
  closeOlar() {
    this.modalRefOlars.hide();
    //$('.modal').css({"display": "none"});
  }

  onSessionExpired() {
    this.sessionModalRef.hide();
    //$('.modal').css({"display": "none"});
    this.webstorage.clear('localst_userservicerequest', 'LOCAL');
    //localStorage.clear();
    this.router.navigate(['home'])
  }


  overlayOpen() {
    this.overlayDisplay = true;
  }

  closeOverlay() {
    this.overlayDisplay = false;
  }

  contactUsEventEmitter(event) {
    this.overlayDisplay = false;
  }

  onChatStartClick() {
    this.overlayDisplay = false;
    this.window && this.window.$zoho.salesiq.floatwindow.visible('show');
  }



  // Method to handle the click event
  onCallClick(phonenumber) {
    document.location.href = 'tel:' + phonenumber;
  }

  //Harish

  onValueChange(value) {
    if (this.datepicker) {

      this.datepicker.hide();
      //$('.modal').css({"display": "none"});
    }
  }
  onCheckStatusClick() {
    let servicetype = this.webstorage.sessionSt_service_type;
    var companyid = this.webstorage.sessionSt_location_selected.oocls_company_id;
    if (servicetype === 'DINE_IN') {
      this.router.navigate(['status-dinein'], { queryParams: { companyId: companyid, serviceId: this.customer_order['ooco_oodcdr_guid'] } });
    } else if (servicetype === 'COLLECTION') {
      this.router.navigate(['status-collection'], { queryParams: { companyId: companyid, serviceId: this.customer_order['ooco_oodcdr_guid'] } });
    } else if (servicetype === 'DELIVERY') {
      this.router.navigate(['status-delivery'], { queryParams: { companyId: companyid, serviceId: this.customer_order['ooco_oodcdr_guid'] } });
    }
    this.webstorage.sessionSt_user_order_reference = undefined;
    this.orderstatusModalRef.hide();
  }


  paynowclickeddisable = false;
  onPaynowClick() {
    this.paymentErrorMsg = '';
    let paymenttype = '';
    let index = 0;
    let selectedpaymenttype = this.paymentTypes.find((obj, ind) => {
      index = ind;
      return obj.option_selected === true;
    });
    if (selectedpaymenttype === undefined) {
      const message = this.translate.instant('CHECKOUT_PAGE.SELECT_METHOD');
      this.paymentErrorMsg = message;
      this.toastService.show(message);
      return;
    } else if (selectedpaymenttype.type === 'card') {
      paymenttype = 'Visa_MasterCard';
    } else if (selectedpaymenttype.type === 'payatcounter') {
      paymenttype = 'Reserved';
    } else if (selectedpaymenttype.type === 'loyalty') {
      paymenttype = 'Loyalty';
    } else if (selectedpaymenttype.type === 'DuitNow') {
      paymenttype = 'DuitNow';
    } else if (selectedpaymenttype.type === 'fpx') {
      this.customerDetailsForm.reset();
      paymenttype = 'FPX_PERSONAL_ACCOUNT';
      this.paynowclickeddisable = true;
      this.customerDetailsModalRef = this.modalService.show(this.customerDetails, this.configCustomerDetails);
      return;
    } else if (selectedpaymenttype.type === 'ewallets') {
      paymenttype = 'ewallets';
    }
    this.paynowclickeddisable = true;

    // for (let i = 0; i < 1; i++) {

    //  setTimeout(() => {
    this.onPaymentClick(paymenttype, false);
    //  }, 5000 * i);
    // }



  }


  onCustomerDetailCloseClick() {
    this.customerDetailsModalRef.hide();
    this.paynowclickeddisable = false;
  }

  onCustomerNextClick() {
    if (this.customerDetailsForm.invalid) {
      Object.keys(this.customerDetailsForm.controls).forEach(key => {
        this.customerDetailsForm.get(key).markAsDirty();
      });
      return;
    }

    let number = '';
    let countryCode = '';
    number = this.customerDetailsForm.getRawValue().contact.number;
    countryCode = this.customerDetailsForm.getRawValue().contact.countryCode;
    number = number.replace('-', '').replace(' ', '');
    const dialCode = this.customerDetailsForm.getRawValue().contact.dialCode;
    let dialWithoutCode = dialCode.replace(/\D/g, '');
    let input = {
      customer_firstname: this.customerDetailsForm.getRawValue().name,
      customer_email: this.customerDetailsForm.getRawValue().email,
      country_dial_code: dialWithoutCode,
      customer_mobile: number,
      customer_key: this.webstorage.localSt_olar_key,
      customer_client_key: this.webstorage.localSt_client_id
    };

    this.ecomservice.httpPost(EcomNetworkUtils.POST_FPX_USER_SAVE, input, '', true).subscribe(response => {
      if (response.isSuccess) {
        this.onPaymentClick('FPX_PERSONAL_ACCOUNT', false);
      } else {
        this.paynowclickeddisable = false;
        this.customerErrorMsg = 'Server error please check input and try again!.';
      }
    });

  }

  selectedFPX = '';
  selectedWallet = '';
  ghlPaymentType = '';
  showfpxlist = false;
  showwalletlist = false;
  cardselected = false;
  paymentErrorMsg = '';
  customerErrorMsg = '';

  OnPaymentSelect(event, type) {
    this.ghlPaymentType = type;
    this.showfpxlist = false;
    this.showwalletlist = false;
    this.cardselected = false;
    if (type === 'CARD') {
      this.cardselected = event.target.checked;
    } else if (type === 'FPX') {
      this.showfpxlist = event.target.checked;
    } else if (type === 'EWALLETS') {
      this.showwalletlist = event.target.checked;
    }
  }

  onFpxChange(method) {
  }

  onWalletChange(method) {
  }



  defaultPaymentTypes = [
    {
      type: 'fpx',
      collapsed: true,
      name: '',
      selected: '',
      staging_list: [
        { value: 'FPXD_ABB0233', text: 'Affin Bank Berhad', selected: false },
        { value: 'FPXD_ABB0234', text: 'Affin Bank Berhad B2C - Test ID', selected: false },
        { value: 'FPXD_ABMB0212', text: 'Alliance Bank Malaysia Berhad', selected: false },
        { value: 'FPXD_AGRO01', text: 'BANK PERTANIAN MALAYSIA BERHAD (AGROBANK)', selected: false },
        { value: 'FPXD_AMBB0209', text: 'AmBank Malaysia Berhad', selected: false },
        { value: 'FPXD_BCBB0235', text: 'CIMB Bank Berhad', selected: false },
        { value: 'FPXD_BIMB0340', text: 'Bank Islam Malaysia Berhad', selected: false },
        { value: 'FPXD_BKRM0602', text: 'Bank Kerjasama Rakyat Malaysia Berhad', selected: false },
        { value: 'FPXD_BMMB0341', text: 'Bank Muamalat Malaysia Berhad', selected: false },
        { value: 'FXPD_BSN0601', text: 'Bank Simpanan Nasional', selected: false },
        { value: 'FXPD_BOCM01', text: 'Bank Of China (M) Berhad', selected: false },
        { value: 'FXPD_CIT0219', text: 'CITI Bank Berhad', selected: false },
        { value: 'FPXD_HLB0224', text: 'Hong Leong Bank Berhad', selected: false },
        { value: 'FPXD_HSBC0223', text: 'HSBC Bank Malaysia Berhad', selected: false },
        { value: 'FPXD_KFH0346', text: 'Kuwait Finance House (Malaysia) Berhad', selected: false },
        { value: 'FPXD_MBB0228', text: 'Malayan Banking Berhad (M2E)', selected: false },
        { value: 'FPXD_MB2U0227', text: 'Malayan Banking Berhad (M2U)', selected: false },
        { value: 'FPXD_OCBC0229', text: 'OCBC Bank Malaysia Berhad', selected: false },
        { value: 'FPXD_PBB0233', text: 'Public Bank Berhad', selected: false },
        { value: 'FPXD_RHB0218', text: 'RHB Bank Berhad', selected: false },
        { value: 'BOCM01', text: 'Bank Of China (M) Berhad' },
        //{ value: 'FPXD_TEST0021', text: 'SBI BANK A' }, //GHL bank code
        { value: 'TEST0021', text: 'SBI BANK A', selected: false }, // RH Bank code and rest in the list are GHL staging codes
        { value: 'FPXD_TEST0022', text: 'SBI BANK B', selected: false },
        { value: 'FPXD_TEST0023', text: 'SBI BANK C', selected: false },
        { value: 'FPXD_SCB0216', text: 'Standard Chartered Bank', selected: false },
        { value: 'FPXD_UOB0226', text: 'United Overseas Bank', selected: false },
        { value: 'FPXD_UOB0229', text: 'United Overseas Bank - B2C Test', selected: false },
        { value: 'FPXD_UOB0229', text: 'United Overseas Bank - B2C Test', selected: false }
      ],
      production_list: [
        { value: 'ABB0233', text: 'Affin Bank Berhad', selected: false },
        { value: 'ABMB0212', text: 'Alliance Bank Malaysia Berhad', selected: false },
        { value: 'AGRO01', text: 'BANK PERTANIAN MALAYSIA BERHAD (AGROBANK)', selected: false },
        { value: 'AMBB0209', text: 'AmBank Malaysia Berhad', selected: false },
        { value: 'BIMB0340', text: 'Bank Islam Malaysia Berhad', selected: false },
        { value: 'BMMB0341', text: 'Bank Muamalat Malaysia Berhad', selected: false },
        { value: 'BKRM0602', text: 'Bank Kerjasama Rakyat Malaysia Berhad', selected: false },
        { value: 'BSN0601', text: 'Bank Simpanan Nasional', selected: false },
        { value: 'BCBB0235', text: 'CIMB Bank Berhad', selected: false },
        { value: 'BOCM01', text: 'Bank Of China (M) Berhad' },
        { value: 'HLB0224', text: 'Hong Leong Bank Berhad', selected: false },
        { value: 'HSBC0223', text: 'HSBC Bank Malaysia Berhad', selected: false },
        { value: 'KFH0346', text: 'Kuwait Finance House (Malaysia) Berhad', selected: false },
        { value: 'MBB0228', text: 'Malayan Banking Berhad (M2E)', selected: false },
        { value: 'MB2U0227', text: 'Malayan Banking Berhad (M2U)', selected: false },
        { value: 'OCBC0229', text: 'OCBC Bank Malaysia Berhad', selected: false },
        { value: 'PBB0233', text: 'Public Bank Berhad', selected: false },
        { value: 'RHB0218', text: 'RHB Bank Berhad', selected: false },
        { value: 'SCB0216', text: 'Standard Chartered Bank', selected: false },
        { value: 'UOB0226', text: 'United Overseas Bank', selected: false }
      ],
      showicon: true,
      option_selected: false
    },
    {
      type: 'ewallets',
      collapsed: true,
      name: 'e-Wallets',
      selected: '',
      staging_list: [
        { value: 'Touch_n_Go', text: 'TNG', selected: false, description: "easier if you have TNG app" },
        { value: 'Grab_Pay', text: 'GrabPay', selected: false },
        {
          value: 'Maybank_QR', text: 'MAE', selected: false,
          description: "when you receive QR code, take screenshot and save to your gallery. Go to MEA app, press scan and then press,",
          subDescription: '"<strong>scan QR code from gallery</strong>"'
        },
        { value: 'Axiata_Boost', text: 'Axiata Boost', selected: false },
        { value: 'Alipay_Online', text: 'Alipay Online', selected: false },
        // { value: 'WeChat_Pay', text: 'WeChat Pay', selected: false },
        // { value: 'UPI_QR_Code', text: 'UPI QR Code', selected: false },
        // { value: 'MerchanTrade', text: 'Merchantrade Money', selected: false },
        // { value: 'ShopeePay', text: 'ShopeePay', selected: false },
        // { value: 'B_Infinite_Pay', text: 'B Infinite Pay', selected: false },
        // { value: 'WannaPay', text: 'Wanna Pay', selected: false },
        // { value: 'DuitNow_QR', text: 'DuitNow QR', selected: false },
        // { value: 'Union_Pay_International', text: 'Union Pay International', selected: false },
      ],
      production_list: [
        {
          value: 'Touch_n_Go', text: 'TNG', selected: false,
          description: "easier if you have TNG app"
        },
        { value: 'Grab_Pay', text: 'GrabPay', selected: false },
        {
          value: 'Maybank_QR', text: 'MAE ', selected: false,
          description: "when you receive QR code, take screenshot and save to your gallery. Go to MEA app, press scan and then press,",
          subDescription: '"<strong>scan QR code from gallery</strong>"'
        },
        { value: 'Axiata_Boost', text: 'Boost', selected: false },
        { value: 'Alipay_Online', text: 'Alipay Online', selected: false },
        // { value: 'WeChat_Pay', text: 'WeChat Pay', selected: false },
        // { value: 'UPI_QR_Code', text: 'UPI QR Code', selected: false },
        // { value: 'MerchanTrade', text: 'Merchantrade Money', selected: false },
        // { value: 'ShopeePay', text: 'ShopeePay', selected: false },
        // { value: 'B_Infinite_Pay', text: 'B Infinite Pay', selected: false },
        // { value: 'WannaPay', text: 'Wanna Pay', selected: false },
        // { value: 'DuitNow_QR', text: 'DuitNow QR', selected: false },
        // { value: 'Union_Pay_International', text: 'Union Pay International', selected: false },
      ],
      showicon: true,
      option_selected: false
    },
    {
      type: 'card',
      collapsed: true,
      name: 'Credit/Debit Card',
      selected: '',
      staging_list: [],
      production_list: [],
      showicon: false,
      option_selected: false
    },
    {
      type: 'DuitNow',
      collapsed: true,
      name: 'Duit Now',
      selected: '',
      staging_list: [],
      production_list: [],
      showicon: false,
      option_selected: false
    },
    {
      type: 'payatcounter',
      collapsed: true,
      name: 'Pay at Counter',
      selected: '',
      staging_list: [],
      production_list: [],
      showicon: false,
      option_selected: false
    }
  ];

  paymenttypeselected = '';
  payatcountenabled = false;

  onPaymentExpand(type, index, collapsed) {
    this.payatcountenabled = false;
    this.paymenttypeselected = type['type'];
    if (type['type'] === 'card') {
      this.paymentTypes.forEach(element => {
        element['selected'] = '';
        element['option_selected'] = false;
        element.staging_list.forEach(ptype => {
          ptype.selected = false;
        });
        element.production_list.forEach(ptype => {
          ptype.selected = false;
        });
        element.collapsed = true;
      });
      this.paymentTypes[index].selected = 'card';
      this.paymentTypes[index].option_selected = true;
    } else if (type['type'] === 'payatcounter') {
      // allow payatcounter for QR orders only
      if (this.showPayAtCounter) {
        this.payatcountenabled = true;
        this.paymentTypes.forEach(element => {
          element['selected'] = '';
          element['option_selected'] = false;
          element.staging_list.forEach(ptype => {
            ptype.selected = false;
          });
          element.production_list.forEach(ptype => {
            ptype.selected = false;
          });
          element.collapsed = true;
        });
        this.paymentTypes[index].selected = 'payatcounter';
        this.paymentTypes[index].option_selected = true;
      } else if (this.chargetoRoom && this.serviceType === 'DINE_IN') {
        this.payatcountenabled = true;
        this.paymentTypes.forEach(element => {
          element['selected'] = '';
          element['option_selected'] = false;
          element.staging_list.forEach(ptype => {
            ptype.selected = false;
          });
          element.production_list.forEach(ptype => {
            ptype.selected = false;
          });
          element.collapsed = true;
        });
        this.paymentTypes[index].selected = 'payatcounter';
        this.paymentTypes[index].option_selected = true;
      }
    } else if (type['type'] === 'loyalty') {



      this.paymentTypes.forEach(element => {
        element['selected'] = '';
        element['option_selected'] = false;
        element.staging_list.forEach(ptype => {
          ptype.selected = false;
        });
        element.production_list.forEach(ptype => {
          ptype.selected = false;
        });
        element.collapsed = true;
      });
      this.paymentTypes[index].selected = 'loyalty';
      this.paymentTypes[index].option_selected = true;

    } else if (type['type'] === 'DuitNow') {

      this.paymentTypes.forEach(element => {
        element['selected'] = '';
        element['option_selected'] = false;
        element.staging_list.forEach(ptype => {
          ptype.selected = false;
        });
        element.production_list.forEach(ptype => {
          ptype.selected = false;
        });
        element.collapsed = true;
      });
      this.paymentTypes[index].selected = 'DuitNow';
      this.paymentTypes[index].option_selected = true;

    }

    else {
      this.paymentTypes[index].collapsed = !collapsed;
    }

    let paymentIdDetails = this.getPaymentIdByType();
    console.log(paymentIdDetails);
  }

  onPaymentTypeSelect(event, ptype, option, ptypeIndex, optionIndex) {
    this.paymentTypes[ptypeIndex].collapsed = true;
    this.paymentTypes.forEach(element => {
      element['selected'] = '';
      element['option_selected'] = false;
      element.staging_list.forEach(type => {
        type.selected = false;
      });
      element.production_list.forEach(type => {
        type.selected = false;
      });
    });
    if (event.target.checked) {
      this.paymentTypes[ptypeIndex].selected = option['text'];
      this.paymentTypes[ptypeIndex].option_selected = true;
      if (this.environment === 'Production') {
        this.paymentTypes[ptypeIndex].production_list[optionIndex].selected = true;
      } else {
        this.paymentTypes[ptypeIndex].staging_list[optionIndex].selected = true;
      }
    } else {
      this.paymentTypes[ptypeIndex].selected = '';
    }

    let paymentIdDetails = this.getPaymentIdByType();
    console.log(paymentIdDetails);
  }

  testPaymentLocal(amount, refNumber) {
    const randomNumber = Math.floor(Math.random() * 1000000000000000000);

    const model = {
      Revpay_Merchant_ID: "MER00000003757",
      Payment_ID: 3,
      Bank_Code: "TEST0021",
      Transaction_ID: `UT${randomNumber.toString().padStart(18, '0')}`,
      Reference_Number: refNumber,
      Amount: amount,
      Currency: 0,
      Transaction_Description: "DINE_IN",
      Response_Code: "00",
      Error_Description: "Payment is successful.",
      Settlement_Amount: 25.34,
      Settlement_Currency: "MYR",
      Settlement_FX_Rate: 1.000000,
      Key_Index: 1,
      Signature: "733ffa385ffdd4e6b6cdc5048da9fd25d8ff7d80ae6c7937754e6278710166ce63a773f4b1de9b99a6cff866948dc55db543772a4d671462c1e00aab7f12247c",
      Request_Datetime: Date.now(),
      Response_Datetime: Date.now(),
      Promo_Code: null
    };

    this.ecomservice.httpPost('paymentsfront', model, '', true).subscribe(response => {
      //console.log(response.isSuccess);
    });
  }

  get totalLoyaltyAmount(): number {
    const user = this.settingService.getUserInfo();
    if (user && user.userPkid > 0) {
      const amount = user.points && user.ratio ? Number((user.originPoints - this.usedPoints) / user.ratio) : 0;
      return amount;
    }
    return 0;
  }

  get totalLoyaltyPoints(): number {
    const user = this.settingService.getUserInfo();
    if (user && user.userPkid > 0) {
      const amount = user.originPoints - this.usedPoints
      return amount;
    }
    return 0;
  }


  get usedPoints(): number {
    let point = 0;
    if (!this.userSelectedStore || !this.userSelectedStore.storeCart || !this.userSelectedStore.storeCart.orderItems) return 0;

    const userService = this.settingService.getUserSerivce();

    if (userService && userService.entireReward) {
      point = userService.entireReward.point;
    }

    const totalRewardPoints = this.userSelectedStore.storeCart.orderItems
      .filter(item => item.hasReward)
      .reduce((total, item) => total + item.reward.point, 0);

    return totalRewardPoints + point;
  }

}
